// import React, { useState, useEffect } from 'react';
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import axios from 'axios';
// import { styled } from '@mui/material/styles';
// import {
//     Box,
//     Typography,
//     Grid,
//     Button,
//     Paper,
//     Divider,
//     Dialog,
//     DialogTitle,
//     DialogActions,
//     DialogContentText,
//     DialogContent,
//     TextField,
//     FormControl,
//     FormLabel,
//     RadioGroup,
//     FormControlLabel,
//     Radio,
//     MenuItem,
//     TableContainer,
//     Table,
//     TableHead,
//     TableBody,
//     TableRow,
//     TableCell,
//     TablePagination,
//     InputLabel,
//     Select,
//     Snackbar,
//     Alert,
//     CircularProgress,
//     Chip,
//     Card,
//     CardContent,
//     Modal,
//     LinearProgress, 
// } from '@mui/material';
// import {

//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip as ChartTooltip,
//     Legend,
//     ResponsiveContainer
// } from 'recharts';
// import { alpha } from '@mui/material/styles';
// import AssignmentIcon from '@mui/icons-material/Assignment';
// import DateRangeIcon from '@mui/icons-material/DateRange';
// import EventIcon from '@mui/icons-material/Event';
// import WbSunnyIcon from '@mui/icons-material/WbSunny';
// import { useNavigate } from 'react-router-dom';
// import {
//     BarChart,
//     PendingActions,
//     LocalHospital,
//     Spa,
//     KeyboardDoubleArrowRight,
//     Public,
//     Flag,
//     FilterList,
//     Search,
//     Sort,
//     ArrowDownward,
//     ArrowUpward,
//     CalendarMonth,
//     Comment
// } from "@mui/icons-material";
// import TokenExpirePopup from '../../components/TokenExpirePopup';
// import { localAxiosGet, localAxiosToken } from '../../Axios/axios';

// const StyledGridItem = styled(Grid)(({ theme }) => ({
//     marginBottom: theme.spacing(3),
// }));

// const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
//     marginRight: theme.spacing(3),
//     '& .MuiRadio-root': {
//         color: theme.palette.primary.main,
//     },
//     '& .MuiRadio-root.Mui-checked': {
//         color: theme.palette.secondary.main,
//     },
// }));
// const labelColor = 'text.secondary';
// const valueColor = '#1976d2';


// const EmployeeLeaveManagement = () => {

//     const [isLeavesPopupOpen, setIsLeavesPopupOpen] = useState(false);
//     const [isDaysFormOpen, setIsDaysFormOpen] = useState(false);
//     const [startDate, setStartDate] = useState(dayjs());
//     const [endDate, setEndDate] = useState(dayjs());
//     const [isHolidaysPopupOpen, setIsHolidaysPopupOpen] = useState(false);
//     const [leaveType, setLeaveType] = useState('');
//     const [showEndDate, setShowEndDate] = useState(false);
//     const [leaveReason, setLeaveReason] = useState('');
//     const [leaveReasonOtherFieldDisplay, setLeaveReasonOtherFieldDisplay] = useState(false);
//     const [otherReason, setOtherReason] = useState('');
//     const [comments, setComments] = useState('');
//     const today = dayjs();
// const tomorrow = today.add(1, 'day');
// const [dateValidationMessage, setDateValidationMessage] = useState('');

//     const [reportManager, setReportManager] = useState(localStorage.getItem('reportingmanagerId') || '');
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const navigate = useNavigate()
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: '',
//         severity: 'success'
//     });
//     const [holidays, setHolidays] = useState([]);
//     const [loadingHolidays, setLoadingHolidays] = useState(false);
//     const [holidayYear, setHolidayYear] = useState(new Date().getFullYear());
//     const [holidayError, setHolidayError] = useState('');

//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(5);

//     const [leaveBalance, setLeaveBalance] = useState([]);
//     const [loadingLeaveBalance, setLoadingLeaveBalance] = useState(false);
//     const [leaveBalanceError, setLeaveBalanceError] = useState('');
//     const [totalLeaves, setTotalLeaves] = useState(0);
//     const [casualLeaveBalance, setCasualLeaveBalance] = useState(0);
//     const [sickLeaveBalance, setSickLeaveBalance] = useState(0);
//     const [pendingRequests, setPendingRequests] = useState(0);

//     const [leaveTypes, setLeaveTypes] = useState([]);
//     const [loadingLeaveTypes, setLoadingLeaveTypes] = useState(false);
//     const [leaveTypesError, setLeaveTypesError] = useState('');

//     const [managers, setManagers] = useState([]);
//     const [loadingManagers, setLoadingManagers] = useState(false);
//     const [managersError, setManagersError] = useState('');

//     const [isMyLeavesPopupOpen, setIsMyLeavesPopupOpen] = useState(false);
//     const [myLeaves, setMyLeaves] = useState([]);
//     const [loadingMyLeaves, setLoadingMyLeaves] = useState(false);
//     const [myLeavesError, setMyLeavesError] = useState('');
//     const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//     const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
//     const [pageMyLeaves, setPageMyLeaves] = useState(0);
//     const [rowsPerPageMyLeaves, setRowsPerPageMyLeaves] = useState(6);
//     const [sortBy, setSortBy] = useState('start_date');
//     const [sortOrder, setSortOrder] = useState('asc');
//     const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
//     const token = localStorage.getItem('accessToken');
//     const reportingmanagerId = localStorage.getItem('reportingmanagerId');
//     console.log('reportingmanagerId', reportingmanagerId);

//     const [isLeaveBalancePopupOpen, setIsLeaveBalancePopupOpen] = useState(false);
//     const [leaveBalanceData, setLeaveBalanceData] = useState([]);
//     const [loadingLeaveBalanceData, setLoadingLeaveBalanceData] = useState(false);
//     const accessToken = localStorage.getItem('accessToken');

//     const [isLeaveBalanceButtonOpen, setIsLeaveBalanceButtonOpen] = useState(false);
//     const [leaveData, setLeaveData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     const fetchLeaveBalanceData = async () => {
//         setLoadingLeaveBalanceData(true);
//         try {
//             const userId = localStorage.getItem('userId');
//             if (!userId) {
//                 throw new Error('User ID not found in localStorage');
//             }

//             const response = await axios(localAxiosGet(`/organization/getEmployeeLeaveBalance?user_id=${userId}`, token));

//             if (response.data && response.data.statusCode === 200) {
//                 console.log('Leave balance response:', response.data);


//                 if (Array.isArray(response.data.message)) {

//                     const transformedData = response.data.message.map(leaveType => ({
//                         name: leaveType.leave_type,
//                         total: leaveType.max_days,
//                         remaining: leaveType.balance_days,
//                         used: leaveType.max_days - leaveType.balance_days
//                     }));

//                     setLeaveBalanceData(transformedData);
//                 } else if (response.data.message && typeof response.data.message === 'object') {

//                     const transformedData = [];


//                     if (response.data.message.leave_types && Array.isArray(response.data.message.leave_types)) {
//                         response.data.message.leave_types.forEach(leaveType => {
//                             transformedData.push({
//                                 name: leaveType.leave_type,
//                                 total: leaveType.max_days,
//                                 remaining: leaveType.balance_days,
//                                 used: leaveType.max_days - leaveType.balance_days
//                             });
//                         });
//                     }


//                     if (transformedData.length === 0 && response.data.message.total_leaves !== undefined) {
//                         transformedData.push({
//                             name: "Total Leaves",
//                             total: response.data.message.total_leaves,
//                             remaining: response.data.message.total_leaves - (response.data.message.pending_leaves || 0),
//                             used: response.data.message.pending_leaves || 0
//                         });
//                     }

//                     setLeaveBalanceData(transformedData);
//                 } else {
//                     throw new Error('Unexpected response format from leave balance API');
//                 }
//             } else {
//                 throw new Error(response.data.message?.msg || 'Failed to fetch leave balance');
//             }
//         } catch (error) {
//             console.error('Error fetching leave balance data:', error);
//             setSnackbar({
//                 open: true,
//                 message: 'Failed to load leave balance data. Please try again.',
//                 severity: 'error'
//             });

//             setLeaveBalanceData([]);
//         } finally {
//             setLoadingLeaveBalanceData(false);
//         }
//     };


//     useEffect(() => {
//         if (isLeaveBalancePopupOpen) {
//             fetchLeaveBalanceData();
//         }
//     }, [isLeaveBalancePopupOpen]);

//     useEffect(() => {
//         fetchLeaveBalance();
//         fetchLeaveTypes();
//         // fetchManagers();
//     }, []);

//     useEffect(() => {
//         if (isHolidaysPopupOpen) {
//             fetchHolidays();
//         }
//     }, [isHolidaysPopupOpen, holidayYear]);





//     useEffect(() => {
//         if (isMyLeavesPopupOpen) {
//             fetchMyLeaves();
//         }
//     }, [isMyLeavesPopupOpen, selectedYear, selectedMonth, sortBy, sortOrder, token]);


//     const fetchMyLeaves = async () => {
//         setLoadingMyLeaves(true);
//         setMyLeavesError('');

//         try {
//             const userId = getLocalStorageUserID();
//             if (!userId) {
//                 throw new Error('User ID not found in localStorage');
//             }


//             const response = await axios(localAxiosGet(`/organization/getLeaveHistoryByEmployee?year=${selectedYear}&user_id=${userId}&month=${selectedMonth}`, token))

//             if (response.data.statusCode === 200) {

//                 const formattedLeaves = response.data.result.map((leave, index) => ({
//                     id: index + 1,
//                     start_date: leave.start_date,
//                     end_date: leave.end_date,
//                     leave_type: leave.leave_type,
//                     status: leave.status.toLowerCase(),
//                     reason: leave.reason,
//                     comments: leave.comment || 'No comments provided'
//                 }));



//                 let sortedData = [...formattedLeaves];

//                 sortedData.sort((a, b) => {
//                     if (sortBy === 'start_date') {
//                         const dateA = new Date(a.start_date);
//                         const dateB = new Date(b.start_date);
//                         return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
//                     } else if (sortBy === 'leave_type') {
//                         return sortOrder === 'asc'
//                             ? a.leave_type.localeCompare(b.leave_type)
//                             : b.leave_type.localeCompare(a.leave_type);
//                     } else if (sortBy === 'status') {
//                         return sortOrder === 'asc'
//                             ? a.status.localeCompare(b.status)
//                             : b.status.localeCompare(a.status);
//                     }
//                     return 0;
//                 });

//                 setMyLeaves(sortedData);
//             } else {
//                 throw new Error(response.data.message || 'Failed to fetch leave history');
//             }
//         } catch (error) {
//             console.error('Error fetching leave history:', error);
//             setMyLeavesError('Failed to load leave history. Please try again.');
//             setMyLeaves([]);


//         } finally {
//             setLoadingMyLeaves(false);
//         }
//     };



//     const fetchLeaveTypes = async () => {
//         setLoadingLeaveTypes(true);
//         setLeaveTypesError('');

//         try {
//             const token = localStorage.getItem('accessToken');
//             const organizationId = localStorage.getItem('organizationId');

//             if (!organizationId) {
//                 throw new Error('Organization ID not found in localStorage');
//             }


//             const response = await axios(localAxiosGet(`/organization/getAllLeaveTypes?organization_id=${organizationId}`, token))



//             if (response.data.statusCode === 200) {
//                 setLeaveTypes(response.data.message.leaveTypes);
//             } else {
//                 throw new Error(response.data.message?.msg || 'Failed to fetch leave types');
//             }
//         } catch (error) {
//             console.error('Error fetching leave types:', error);
//             setLeaveTypesError('Failed to load leave types. Please try again.');

//             if (error.response && (error.response.status === 403 || error.response.statusCode === 403)) {
//                 setOpenTokenExpirePopup(true);
//             }
//         } finally {
//             setLoadingLeaveTypes(false);
//         }
//     };



//     const fetchLeaveBalance = async () => {
//         setLoadingLeaveBalance(true);
//         setLeaveBalanceError('');

//         try {
//             const userId = localStorage.getItem('userId');
//             if (!userId) {
//                 throw new Error('User ID not found in localStorage');
//             }


//             const response = await axios(localAxiosGet(`/organization/getEmployeeLeaveBalance?user_id=${userId}`, token))



//             if (response.data && response.data.statusCode === 200) {
//                 setLeaveBalance(response.data.message);
//                 setTotalLeaves(response.data.message.total_leaves);
//                 setPendingRequests(response.data.message.pending_leaves);


//             } else {
//                 throw new Error(response.data.message?.msg || 'Failed to fetch leave balance');
//             }
//         } catch (error) {
//             console.error('Error fetching leave balance:', error);
//             setLeaveBalanceError('Failed to load leave balance. Please try again.');
//         } finally {
//             setLoadingLeaveBalance(false);
//         }
//     };


//     const fetchHolidays = async () => {
//         setLoadingHolidays(true);
//         setHolidayError('');

//         try {

//             const organizationId = localStorage.getItem('organizationId');
//             const locationId = localStorage.getItem('locationId');

//             const response = await axios(localAxiosGet(`/organization/getAllHolidaysByYearAndMonth?year=${holidayYear}&organization_id=${organizationId}&location_id=${locationId}`, token))


//             if (response.data && response.data.statusCode === 200) {
//                 setHolidays(response.data.message.holidays);
//             } else {
//                 throw new Error(response.data.message?.msg || 'Failed to fetch holidays');
//             }
//         } catch (error) {
//             console.error('Error fetching holidays:', error);
//             setHolidayError('Failed to load holidays. Please try again.');
//             setHolidays([]);

//         } finally {
//             setLoadingHolidays(false);
//         }
//     };
//     const handleCloseTokenExpirePopup = () => {
//         setOpenTokenExpirePopup(false);
//         navigate('/');
//     };

//     const handleLeaveTypeSelection = (event) => {
//         const selectedLeaveType = event.target.value;
//         setLeaveType(selectedLeaveType);
//     };

//     const handleLeavesPopup = () => {
//         setIsLeavesPopupOpen(true);
//     }
//     const handleLeavesPopupClose = () => {
//         setIsLeavesPopupOpen(false);
//         resetForm();
//     }
//     const resetForm = () => {
//         setLeaveType('');
//         setIsDaysFormOpen(false);
//         setLeaveReason('');
//         setLeaveReasonOtherFieldDisplay(false);
//         setOtherReason('');
//         setComments('');
//         setStartDate(dayjs());
//         setEndDate(dayjs());
//         setShowEndDate(false);
//     }
//     const handleHolidaysList = () => {
//         setIsHolidaysPopupOpen(true);
//     }
//     const handleHolidaysListClose = () => {
//         setIsHolidaysPopupOpen(false);
//     }
//     const handleYearChange = (event) => {
//         setHolidayYear(event.target.value);
//         setPage(0);
//     };
//     const handleSnackbarClose = () => {
//         setSnackbar({ ...snackbar, open: false });
//     }
//     const handlePageChange = (event, newPage) => {
//         setPage(newPage);
//     };
//     const handleRowsPerPageChange = (event) => {
//         setRowsPerPage(parseInt(event.target.value, 10));
//         setPage(0);
//     };
//     const getLocalStorageUserID = () => {
//         const userID = localStorage.getItem('userId');
//         return userID ? userID : null;
//     };
//     const handleRequestSort = (event, property) => {
//         const isAsc = sortBy === property && sortOrder === 'asc';
//         setSortBy(property);
//         setSortOrder(isAsc ? 'desc' : 'asc');
//     };


//     const handleYearMonthChange = (event) => {
//         if (event.target.name === 'year') {
//             setSelectedYear(parseInt(event.target.value));
//         } else {
//             setSelectedMonth(parseInt(event.target.value));
//         }
//         setPageMyLeaves(0);
//     };

//     const handleSubmitRequest = async () => {




//         if (!leaveType) {
//             setSnackbar({ open: true, message: 'Please select a leave type', severity: 'error' });
//             return;
//         }

//         if (!reportManager) {
//             setSnackbar({ open: true, message: 'Reporting manager information is missing', severity: 'error' });
//             return;
//         }

//         const formattedStartDate = startDate.format('YYYY-MM-DD');
//         const formattedEndDate = endDate.format('YYYY-MM-DD');
//         const organizationId = localStorage.getItem('organizationId');
//         const locationId = localStorage.getItem('locationId');

//         if (!organizationId) {
//             setSnackbar({ open: true, message: 'Organization ID not found', severity: 'error' });
//             return;
//         }

//         const leaveRequest = {
//             user_id: getLocalStorageUserID(),
//             start_date: formattedStartDate,
//             end_date: formattedEndDate,
//             organization_id: parseInt(organizationId, 10),
//             location_id: locationId,
//             leave_type_id: parseInt(leaveType, 10),
//             report_manager_id: reportManager,
//             leave_duration_type: "FULL_DAY",
//             reason: comments || 'No reason provided'
//         };

//         console.log('Using report_manager_id:', reportManager);
//         console.log('Leave Request Payload:', leaveRequest);

//         setIsSubmitting(true);

//         try {
//             const response = await axios(localAxiosToken('/organization/createLeave', leaveRequest, token));

//             if (response.data && response.data.statusCode === 200) {
//                 setSnackbar({ open: true, message: 'Leave request submitted successfully', severity: 'success' });
//                 setTimeout(() => {
//                     handleLeavesPopupClose();
//                     fetchLeaveBalance();
//                     if (isMyLeavesPopupOpen) {
//                         const newLeave = {
//                             id: myLeaves.length + 1, 
//                             start_date: formattedStartDate,
//                             end_date: formattedEndDate,
//                             leave_type: leaveTypes.find(lt => lt.id.toString() === leaveType)?.leave_type || 'Unknown',
//                             status: 'pending',
//                             reason: comments || 'No reason provided',
//                             comments: 'Waiting for approval'
//                         };
//                         setMyLeaves(prev => [newLeave, ...prev]);
//                     }
//                 }, 1500);
//             } else {

//                 throw new Error(response.data.message?.msg || 'Failed to submit leave request');
//             }
//         } catch (error) {
//             console.error('Error submitting leave request:', error);
//             let errorMessage = 'Failed to submit leave request. Please try again.';
//             if (error.response && error.response.data) {
//                 const { statusCode, message } = error.response.data;
//                 if (statusCode === 400 && message) {
//                     errorMessage = message;
//                 } else if (message && typeof message === 'string') {
//                     errorMessage = message;
//                 } else if (message && typeof message === 'object' && message.msg) {
//                     errorMessage = message.msg;
//                 }
//             } else if (error.message) {
//                 errorMessage = error.message;
//             }
//             setSnackbar({
//                 open: true,
//                 message: errorMessage,
//                 severity: 'error'
//             });
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return 'N/A';
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-GB', {
//             day: '2-digit',
//             month: '2-digit',
//             year: 'numeric'
//         });
//     };

//     const getDayOfWeek = (dateString) => {
//         const date = new Date(dateString);
//         const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
//         return days[date.getDay()];
//     };


//     const getStatusColor = (status) => {
//         switch (status?.toLowerCase()) {
//             case 'approved':
//                 return 'success';
//             case 'rejected':
//                 return 'error';
//             case 'pending':
//                 return 'warning';
//             default:
//                 return 'default';
//         }
//     };


//     const getStatusIcon = (status) => {
//         switch (status?.toLowerCase()) {
//             case 'approved':
//                 return <Flag />;
//             case 'rejected':
//                 return null;
//             case 'pending':
//                 return <PendingActions />;
//             default:
//                 return null;
//         }
//     };

//     const fetchLeaveTypeBalance = async () => {
//         setLoading(true);
//         setError(null);
//         const userId = localStorage.getItem('userId');
//         try {
//             const response = await axios(localAxiosGet(`/organization/getAllLeaveTypesByEmpId?user_id=${userId}`, accessToken));

//             if (response.data.statusCode === 200 && response.data.status === 'SUCCESS') {
//                 setLeaveData(response.data.message.leaveTypesWithBalance);
//             } else {
//                 setError(response.data.message || 'Failed to fetch leave balance.');
//             }
//         } catch (e) {
//             setError('Error fetching data: ' + e.message);
//             setLeaveData([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleLeaveBalanceButton = async () => {
//         await fetchLeaveTypeBalance();

//         setIsLeaveBalanceButtonOpen(true);
//     };





//     return (
//         <div>
//             <Box sx={{ padding: 0, height: '80vh' }}>
//                 <Typography variant="h4" fontWeight="bold" sx={{ mb: 4 }}>
//                     Manage Leaves
//                 </Typography>
//                 <Grid container spacing={3} sx={{ mb: 4 }}>
//                     <Grid item xs={12} sm={6} md={4}>
//                         <Paper sx={{ p: 2, bgcolor: '#fff0f6' }}>
//                             <Typography variant="h6">Total Leaves</Typography>
//                             <Typography variant="h4" fontWeight="bold">
//                                 {loadingLeaveBalance ? (
//                                     <CircularProgress size={30} />
//                                 ) : (
//                                     totalLeaves
//                                 )}
//                             </Typography>
//                             <BarChart sx={{ color: '#ff6b6b', fontSize: 40 }} />
//                         </Paper>
//                     </Grid>


//                     <Grid item xs={12} sm={6} md={4}>
//                         <Paper sx={{ p: 2, bgcolor: '#e6fcf5' }}>
//                             <Typography variant="h6">Remaining Leaves</Typography>
//                             <Typography variant="h4" fontWeight="bold">
//                                 {loadingLeaveBalance ? (
//                                     <CircularProgress size={30} />
//                                 ) : (
//                                     leaveBalance.remaining_leaves
//                                 )}
//                             </Typography>
//                             <Spa sx={{ color: '#38d9a9', fontSize: 40 }} />
//                         </Paper>
//                     </Grid>

//                     <Grid item xs={12} sm={6} md={4}>
//                         <Paper sx={{ p: 2, bgcolor: '#f0f4ff' }}>
//                             <Typography variant="h6">Pending Requests</Typography>
//                             <Typography variant="h4" fontWeight="bold">{pendingRequests}</Typography>
//                             <PendingActions sx={{ color: '#ffd43b', fontSize: 40 }} />
//                         </Paper>
//                     </Grid>
//                 </Grid>
//                 <Grid container spacing={2}>
//                     <Grid item xs={12} md={9}>


//                         <Box display="flex" flexDirection="row" gap={2}>
//                             <Button
//                                 variant="contained"
//                                 color="secondary"
//                                 onClick={() => setIsMyLeavesPopupOpen(true)}
//                                 sx={{
//                                     flex: 1,
//                                     padding: 2,
//                                     textAlign: "left",
//                                     backgroundColor: '#6a1b9a',
//                                     '&:hover': {
//                                         backgroundColor: '#4a148c'
//                                     }
//                                 }}
//                                 endIcon={<KeyboardDoubleArrowRight sx={{ fontSize: "2.5rem", width: 30, height: 30 }} />}
//                             >
//                                 <Typography>My Leaves</Typography>
//                             </Button>




//                             <Button
//                                 variant="contained"
//                                 color="primary"
//                                 onClick={handleLeavesPopup}
//                                 sx={{
//                                     flex: 1,
//                                     padding: 2,
//                                     textAlign: "left",
//                                 }}
//                                 endIcon={<KeyboardDoubleArrowRight sx={{ fontSize: "2.5rem", width: 30, height: 30 }} />}
//                             >
//                                 <Typography>Apply for Leave</Typography>
//                             </Button>
//                             <Button
//                                 variant="contained"
//                                 sx={{ flex: 1, padding: 2, backgroundColor: '#b841d0' }}
//                                 onClick={handleHolidaysList}
//                                 endIcon={<KeyboardDoubleArrowRight sx={{ fontSize: "2.5rem", width: 30, height: 30 }} />}
//                             >
//                                 <Typography>Holidays List</Typography>
//                             </Button>

//                             <Button
//                                 variant="contained"
//                                 sx={{ flex: 1, padding: 2, backgroundColor: '#b841d0' }}
//                                 onClick={handleLeaveBalanceButton}
//                                 endIcon={<KeyboardDoubleArrowRight sx={{ fontSize: "2.5rem", width: 30, height: 30 }} />}
//                             >
//                                 <Typography>Leave Balance</Typography>
//                             </Button>

//                         </Box>
//                     </Grid>
//                 </Grid>


//                 <Dialog
//                     open={isMyLeavesPopupOpen}
//                     onClose={() => setIsMyLeavesPopupOpen(false)}
//                     maxWidth="md"
//                     fullWidth
//                     PaperProps={{
//                         style: {
//                             borderRadius: '16px',
//                         },
//                     }}
//                 >
//                     <Box
//                         sx={{
//                             background: 'linear-gradient(90deg, #6a1b9a 0%, #8e24aa 100%)',
//                             p: 3,
//                             color: 'white',
//                             borderTopLeftRadius: '16px',
//                             borderTopRightRadius: '16px',
//                         }}
//                     >
//                         <Typography variant="h5" fontWeight="500">
//                             My Leave History
//                         </Typography>
//                     </Box>
//                     <DialogContent sx={{ p: 3 }}>
//                         <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                             <Box sx={{ display: 'flex', gap: 2 }}>

//                                 <FormControl sx={{ minWidth: 120 }}>
//                                     <InputLabel id="year-select-label">Year</InputLabel>
//                                     <Select
//                                         labelId="year-select-label"
//                                         value={selectedYear}
//                                         onChange={handleYearMonthChange}
//                                         name="year"
//                                         sx={{ borderRadius: '8px' }}
//                                     >
//                                         {[2023, 2024, 2025].filter(year => year <= new Date().getFullYear() + 1).map((year) => (
//                                             <MenuItem key={year} value={year}>{year}</MenuItem>
//                                         ))}
//                                     </Select>
//                                 </FormControl>
//                                 <FormControl sx={{ minWidth: 120 }}>
//                                     <InputLabel id="month-select-label">Month</InputLabel>
//                                     <Select
//                                         labelId="month-select-label"
//                                         value={selectedMonth}
//                                         onChange={handleYearMonthChange}
//                                         name="month"
//                                         sx={{ borderRadius: '8px' }}
//                                     >
//                                         {[
//                                             { value: 1, label: 'January' },
//                                             { value: 2, label: 'February' },
//                                             { value: 3, label: 'March' },
//                                             { value: 4, label: 'April' },
//                                             { value: 5, label: 'May' },
//                                             { value: 6, label: 'June' },
//                                             { value: 7, label: 'July' },
//                                             { value: 8, label: 'August' },
//                                             { value: 9, label: 'September' },
//                                             { value: 10, label: 'October' },
//                                             { value: 11, label: 'November' },
//                                             { value: 12, label: 'December' }
//                                         ]
//                                             .filter(month =>
//                                                 selectedYear < new Date().getFullYear() ||
//                                                 month.value <= new Date().getMonth() + 1
//                                             )
//                                             .map((month) => (
//                                                 <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
//                                             ))}
//                                     </Select>
//                                 </FormControl>
//                             </Box>
//                         </Box>

//                         {loadingMyLeaves ? (
//                             <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
//                                 <CircularProgress />
//                             </Box>
//                         ) : myLeavesError ? (
//                             <Alert severity="error" sx={{ mb: 2 }}>
//                                 {myLeavesError}
//                             </Alert>
//                         ) : (
//                             <>
//                                 {myLeaves.length > 0 ? (
//                                     <Grid container spacing={2}>
//                                         {myLeaves
//                                             .slice(pageMyLeaves * rowsPerPageMyLeaves, pageMyLeaves * rowsPerPageMyLeaves + rowsPerPageMyLeaves)
//                                             .map((leave, index) => (
//                                                 <Grid item xs={12} sm={6} md={4} key={leave.id || index}>
//                                                     <Card
//                                                         sx={{
//                                                             height: '100%',
//                                                             display: 'flex',
//                                                             flexDirection: 'column',
//                                                             boxShadow: 3,
//                                                             borderRadius: 2,
//                                                             transition: 'transform 0.2s, box-shadow 0.2s',
//                                                             '&:hover': {
//                                                                 transform: 'translateY(-4px)',
//                                                                 boxShadow: 6,
//                                                             }
//                                                         }}
//                                                     >
//                                                         <Box
//                                                             sx={{
//                                                                 p: 2,
//                                                                 backgroundColor: leave.leave_type?.includes('Sick') ? '#ffebee' :
//                                                                     leave.leave_type?.includes('Casual') ? '#e8f5e9' :
//                                                                         leave.leave_type?.includes('Paid') ? '#e3f2fd' : '#f3e5f5',
//                                                                 borderBottom: '1px solid #eee'
//                                                             }}
//                                                         >
//                                                             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                                                 <Chip
//                                                                     label={leave.leave_type || "N/A"}
//                                                                     size="small"
//                                                                     sx={{
//                                                                         backgroundColor: leave.leave_type?.includes('Sick') ? '#ffebee' :
//                                                                             leave.leave_type?.includes('Casual') ? '#e8f5e9' :
//                                                                                 leave.leave_type?.includes('Paid') ? '#e3f2fd' : '#f3e5f5',
//                                                                         color: leave.leave_type?.includes('Sick') ? '#c62828' :
//                                                                             leave.leave_type?.includes('Casual') ? '#2e7d32' :
//                                                                                 leave.leave_type?.includes('Paid') ? '#1565c0' : '#6a1b9a',
//                                                                         fontWeight: 500,
//                                                                         border: '1px solid',
//                                                                         borderColor: leave.leave_type?.includes('Sick') ? '#ef9a9a' :
//                                                                             leave.leave_type?.includes('Casual') ? '#a5d6a7' :
//                                                                                 leave.leave_type?.includes('Paid') ? '#90caf9' : '#ce93d8',
//                                                                     }}
//                                                                 />
//                                                                 <Chip
//                                                                     icon={getStatusIcon(leave.status)}
//                                                                     label={leave.status || "Pending"}
//                                                                     size="small"
//                                                                     color={getStatusColor(leave.status)}
//                                                                     variant={leave.status === 'approved' ? "filled" : "outlined"}
//                                                                     sx={{ fontWeight: 500 }}
//                                                                 />
//                                                             </Box>
//                                                         </Box>
//                                                         <CardContent sx={{ flexGrow: 1, p: 2 }}>
//                                                             <Box sx={{ mb: 2 }}>
//                                                                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                                                     <CalendarMonth sx={{ fontSize: 18, color: '#666', mr: 1 }} />
//                                                                     <Typography variant="subtitle2" color="text.secondary">
//                                                                         Date Range
//                                                                     </Typography>
//                                                                 </Box>
//                                                                 <Box sx={{ pl: 3.5 }}>
//                                                                     <Typography variant="body2" fontWeight="medium">
//                                                                         {formatDate(leave.start_date)}
//                                                                     </Typography>
//                                                                     {leave.start_date !== leave.end_date && (
//                                                                         <Typography variant="body2" color="text.secondary">
//                                                                             to {formatDate(leave.end_date)}
//                                                                         </Typography>
//                                                                     )}
//                                                                     <Typography variant="caption" color="text.secondary">
//                                                                         {leave.start_date && getDayOfWeek(leave.start_date)}
//                                                                     </Typography>
//                                                                 </Box>
//                                                             </Box>

//                                                             <Box sx={{ mb: 2 }}>
//                                                                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                                                     <Search sx={{ fontSize: 18, color: '#666', mr: 1 }} />
//                                                                     <Typography variant="subtitle2" color="text.secondary">
//                                                                         Reason
//                                                                     </Typography>
//                                                                 </Box>
//                                                                 <Typography
//                                                                     variant="body2"
//                                                                     sx={{
//                                                                         pl: 3.5,
//                                                                         overflow: 'hidden',
//                                                                         textOverflow: 'ellipsis',
//                                                                         display: '-webkit-box',
//                                                                         WebkitLineClamp: 2,
//                                                                         WebkitBoxOrient: 'vertical'
//                                                                     }}
//                                                                 >
//                                                                     {leave.reason || 'N/A'}
//                                                                 </Typography>
//                                                             </Box>

//                                                             <Box>
//                                                                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                                                     <Comment sx={{ fontSize: 18, color: '#666', mr: 1 }} />
//                                                                     <Typography variant="subtitle2" color="text.secondary">
//                                                                         Comments
//                                                                     </Typography>
//                                                                 </Box>
//                                                                 <Typography
//                                                                     variant="body2"
//                                                                     sx={{
//                                                                         pl: 3.5,
//                                                                         overflow: 'hidden',
//                                                                         textOverflow: 'ellipsis',
//                                                                         display: '-webkit-box',
//                                                                         WebkitLineClamp: 2,
//                                                                         WebkitBoxOrient: 'vertical'
//                                                                     }}
//                                                                 >
//                                                                     {leave.comments || leave.description || 'N/A'}
//                                                                 </Typography>
//                                                             </Box>
//                                                         </CardContent>
//                                                     </Card>
//                                                 </Grid>
//                                             ))}
//                                     </Grid>
//                                 ) : (
//                                     <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 6 }}>
//                                         <EventIcon sx={{ fontSize: 60, color: '#9e9e9e' }} />
//                                         <Typography variant="h6" color="text.secondary">
//                                             No leave records found
//                                         </Typography>


//                                     </Box>
//                                 )}

//                                 {myLeaves.length > 0 && (
//                                     <Box sx={{ mt: 3 }}>
//                                         <TablePagination
//                                             rowsPerPageOptions={[6, 12, 18]}
//                                             component="div"
//                                             count={myLeaves.length}
//                                             rowsPerPage={rowsPerPageMyLeaves}
//                                             page={pageMyLeaves}
//                                             onPageChange={(event, newPage) => setPageMyLeaves(newPage)}
//                                             onRowsPerPageChange={(event) => {
//                                                 setRowsPerPageMyLeaves(parseInt(event.target.value, 10));
//                                                 setPageMyLeaves(0);
//                                             }}
//                                             sx={{ borderTop: '1px solid #e0e0e0' }}
//                                         />
//                                     </Box>
//                                 )}
//                             </>
//                         )}
//                     </DialogContent>
//                     <Box
//                         sx={{
//                             display: 'flex',
//                             justifyContent: 'flex-end',
//                             p: 3,
//                             background: '#f8f9fa',
//                             borderTop: '1px solid #eee',
//                             borderBottomLeftRadius: '16px',
//                             borderBottomRightRadius: '16px',
//                         }}
//                     >
//                         <Button
//                             onClick={() => setIsMyLeavesPopupOpen(false)}
//                             variant="contained"
//                             sx={{
//                                 borderRadius: 8,
//                                 px: 3,
//                                 py: 1,
//                                 backgroundColor: '#6a1b9a',
//                                 '&:hover': {
//                                     backgroundColor: '#4a148c'
//                                 }
//                             }}
//                         >
//                             Close
//                         </Button>
//                     </Box>
//                 </Dialog>



//                 <Dialog
//                     open={isLeaveBalancePopupOpen}
//                     onClose={() => setIsLeaveBalancePopupOpen(false)}
//                     maxWidth="md"
//                     fullWidth
//                     PaperProps={{
//                         style: {
//                             borderRadius: '16px',
//                         },
//                     }}
//                 >
//                     <Box
//                         sx={{
//                             background: 'linear-gradient(90deg, #00796b 0%, #009688 100%)',
//                             p: 3,
//                             color: 'white',
//                             borderTopLeftRadius: '16px',
//                             borderTopRightRadius: '16px',
//                         }}
//                     >
//                         <Typography variant="h5" fontWeight="500">
//                             My Leave Balance
//                         </Typography>
//                     </Box>
//                     <DialogContent sx={{ p: 3 }}>
//                         {loadingLeaveBalanceData ? (
//                             <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
//                                 <CircularProgress />
//                             </Box>
//                         ) : leaveBalanceData.length === 0 ? (
//                             <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 6 }}>
//                                 <EventIcon sx={{ fontSize: 60, color: '#9e9e9e' }} />
//                                 <Typography variant="h6" color="text.secondary">
//                                     No leave balance data found
//                                 </Typography>
//                                 <Typography variant="body2" color="text.secondary">
//                                     There is no leave balance information available at this time.
//                                 </Typography>
//                             </Box>
//                         ) : (
//                             <>
//                                 <Box sx={{ height: 300, mb: 4 }}>
//                                     <ResponsiveContainer width="100%" height="100%">
//                                         <BarChart
//                                             data={leaveBalanceData}
//                                             margin={{
//                                                 top: 20,
//                                                 right: 30,
//                                                 left: 20,
//                                                 bottom: 5,
//                                             }}
//                                         >
//                                             <CartesianGrid strokeDasharray="3 3" />
//                                             <XAxis dataKey="name" />
//                                             <YAxis />
//                                             <ChartTooltip />
//                                             <Legend />
//                                             <Bar dataKey="total" name="Total Allocation" fill="#00796b" />
//                                             <Bar dataKey="used" name="Used" fill="#f57c00" />
//                                             <Bar dataKey="remaining" name="Remaining" fill="#1976d2" />
//                                         </BarChart>
//                                     </ResponsiveContainer>
//                                 </Box>

//                                 <Grid container spacing={3}>
//                                     {leaveBalanceData.map((item, index) => (
//                                         <Grid item xs={12} sm={6} md={4} key={index}>
//                                             <Card sx={{ boxShadow: 2, borderRadius: 2 }}>
//                                                 <CardContent>
//                                                     <Typography variant="h6" sx={{
//                                                         mb: 2,
//                                                         color: item.name.toLowerCase().includes('casual') ? '#2e7d32' :
//                                                             item.name.toLowerCase().includes('sick') ? '#c62828' :
//                                                                 item.name.toLowerCase().includes('total') ? '#1976d2' : '#1565c0'
//                                                     }}>
//                                                         {item.name}
//                                                     </Typography>

//                                                     <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//                                                         <Typography variant="body2" color="text.secondary">
//                                                             Total Allocation
//                                                         </Typography>
//                                                         <Typography variant="body1" fontWeight="bold">
//                                                             {item.total} days
//                                                         </Typography>
//                                                     </Box>

//                                                     <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//                                                         <Typography variant="body2" color="text.secondary">
//                                                             Used
//                                                         </Typography>
//                                                         <Typography variant="body1" fontWeight="bold">
//                                                             {item.used} days
//                                                         </Typography>
//                                                     </Box>

//                                                     <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
//                                                         <Typography variant="body2" color="text.secondary">
//                                                             Remaining
//                                                         </Typography>
//                                                         <Typography variant="body1" fontWeight="bold">
//                                                             {item.remaining} days
//                                                         </Typography>
//                                                     </Box>

//                                                     <LinearProgress
//                                                         variant="determinate"
//                                                         value={(item.used / (item.total || 1)) * 100}
//                                                         sx={{
//                                                             height: 8,
//                                                             borderRadius: 4,
//                                                             backgroundColor: alpha(
//                                                                 item.name.toLowerCase().includes('casual') ? '#2e7d32' :
//                                                                     item.name.toLowerCase().includes('sick') ? '#c62828' :
//                                                                         item.name.toLowerCase().includes('total') ? '#1976d2' : '#1565c0',
//                                                                 0.2
//                                                             ),
//                                                             '& .MuiLinearProgress-bar': {
//                                                                 backgroundColor: item.name.toLowerCase().includes('casual') ? '#2e7d32' :
//                                                                     item.name.toLowerCase().includes('sick') ? '#c62828' :
//                                                                         item.name.toLowerCase().includes('total') ? '#1976d2' : '#1565c0',
//                                                             }
//                                                         }}
//                                                     />

//                                                     <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, textAlign: 'right' }}>
//                                                         {item.total ? ((item.used / item.total) * 100).toFixed(1) : 0}% used
//                                                     </Typography>
//                                                 </CardContent>
//                                             </Card>
//                                         </Grid>
//                                     ))}
//                                 </Grid>
//                             </>
//                         )}
//                     </DialogContent>
//                     <Box
//                         sx={{
//                             display: 'flex',
//                             justifyContent: 'flex-end',
//                             p: 3,
//                             background: '#f8f9fa',
//                             borderTop: '1px solid #eee',
//                             borderBottomLeftRadius: '16px',
//                             borderBottomRightRadius: '16px',
//                         }}
//                     >
//                         <Button
//                             onClick={() => setIsLeaveBalancePopupOpen(false)}
//                             variant="contained"
//                             sx={{
//                                 borderRadius: 8,
//                                 px: 3,
//                                 py: 1,
//                                 backgroundColor: '#00796b',
//                                 '&:hover': {
//                                     backgroundColor: '#00695c'
//                                 }
//                             }}
//                         >
//                             Close
//                         </Button>
//                     </Box>
//                 </Dialog>

//                 <Dialog
//                     open={isLeavesPopupOpen}
//                     onClose={handleLeavesPopupClose}
//                     maxWidth="md"
//                     fullWidth
//                     PaperProps={{
//                         style: {
//                             borderRadius: '16px',
//                         },
//                     }}
//                 >
//                     <DialogTitle sx={{
//                         background: 'linear-gradient(45deg, #1976d2 30%, #1565c0 90%)',
//                         color: 'white',
//                         p: 3,
//                     }}>
//                         <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
//                             Apply for Leave
//                         </Typography>
//                         <Typography variant="subtitle2" sx={{ mt: 1, opacity: 0.8 }}>
//                             Fill in the details below to submit your leave request
//                         </Typography>
//                     </DialogTitle>
//                     <DialogContent sx={{ p: 3 }}>
//                         <Grid container spacing={3} sx={{ mt: 1 }}>
//                             <Grid item xs={12} md={6}>
//                                 <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                     <DatePicker
//                                         label="Start Date"
//                                         value={startDate}
//                                         onChange={(newValue) => {
//                                             setStartDate(newValue);

//                                         }}
//                                         format="DD-MM-YYYY"

//                                         slotProps={{
//                                             textField: {
//                                                 fullWidth: true,
//                                                 sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px' } }
//                                             }
//                                         }}
//                                     />
//                                 </LocalizationProvider>
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                     <DatePicker
//                                         label="End Date"
//                                         value={endDate}
//                                         onChange={(newValue) => setEndDate(newValue)}
//                                         format="DD-MM-YYYY"

//                                         minDate={startDate}
//                                         slotProps={{
//                                             textField: {
//                                                 fullWidth: true,
//                                                 sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px' } }
//                                             }
//                                         }}
//                                     />
//                                 </LocalizationProvider>
//                             </Grid>
//                             <Grid item xs={12} md={6}>
//                                 <FormControl fullWidth>
//                                     <InputLabel>Leave Type</InputLabel>
//                                     <Select
//                                         value={leaveType}
//                                         label="Leave Type"
//                                         onChange={handleLeaveTypeSelection}
//                                         sx={{ borderRadius: '8px' }}
//                                     >
//                                         {loadingLeaveTypes ? (
//                                             <MenuItem disabled>
//                                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                                     <CircularProgress size={20} />
//                                                     <Typography>Loading leave types...</Typography>
//                                                 </Box>
//                                             </MenuItem>
//                                         ) : leaveTypesError ? (
//                                             <MenuItem disabled>
//                                                 <Typography color="error">{leaveTypesError}</Typography>
//                                             </MenuItem>
//                                         ) : (
//                                             leaveTypes.map((type) => (
//                                                 <MenuItem key={type.id} value={type.id.toString()}>
//                                                     {type.leave_type}
//                                                 </MenuItem>
//                                             ))
//                                         )}
//                                     </Select>
//                                     {leaveTypesError && (
//                                         <Typography variant="caption" color="error" sx={{ mt: 1 }}>
//                                             {leaveTypesError}
//                                         </Typography>
//                                     )}
//                                 </FormControl>
//                             </Grid>

//                             <Grid item xs={12}>
//                                 <TextField
//                                     label="Comments"
//                                     multiline
//                                     rows={4}
//                                     fullWidth
//                                     value={comments}
//                                     onChange={(e) => setComments(e.target.value)}
//                                     placeholder="Please provide details about your leave request"
//                                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
//                                 />
//                             </Grid>
//                         </Grid>
//                     </DialogContent>
//                     <DialogActions sx={{ p: 3, pt: 0 }}>
//                         <Button
//                             onClick={handleLeavesPopupClose}
//                             variant="outlined"
//                             sx={{ borderRadius: '8px', px: 3 }}
//                         >
//                             Cancel
//                         </Button>
//                         <Button
//                             onClick={handleSubmitRequest}
//                             variant="contained"
//                             disabled={isSubmitting}
//                             sx={{
//                                 borderRadius: '8px',
//                                 px: 3,
//                                 ml: 2,
//                                 position: 'relative'
//                             }}
//                         >
//                             {isSubmitting ? (
//                                 <>
//                                     <CircularProgress
//                                         size={24}
//                                         sx={{
//                                             position: 'absolute',
//                                             top: '50%',
//                                             left: '50%',
//                                             marginTop: '-12px',
//                                             marginLeft: '-12px',
//                                         }}
//                                     />
//                                     Submitting...
//                                 </>
//                             ) : (
//                                 'Submit Request'
//                             )}
//                         </Button>
//                     </DialogActions>
//                 </Dialog>


//                 <Dialog
//                     open={isHolidaysPopupOpen}
//                     onClose={handleHolidaysListClose}
//                     maxWidth="md"
//                     fullWidth
//                     PaperProps={{
//                         style: {
//                             borderRadius: '16px',
//                         },
//                     }}
//                 >
//                     <Box
//                         sx={{
//                             background: 'linear-gradient(90deg, #b841d0 0%, #9c27b0 100%)',
//                             p: 3,
//                             color: 'white',
//                             borderTopLeftRadius: '16px',
//                             borderTopRightRadius: '16px',
//                         }}
//                     >
//                         <Typography variant="h5" fontWeight="500">
//                             Holidays List
//                         </Typography>
//                     </Box>
//                     <DialogContent sx={{ p: 3 }}>
//                         <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                             <FormControl sx={{ minWidth: 120 }}>
//                                 <InputLabel id="year-select-label">Year</InputLabel>
//                                 <Select
//                                     labelId="year-select-label"
//                                     value={holidayYear}
//                                     onChange={handleYearChange}
//                                     label="Year"
//                                     sx={{ borderRadius: '8px' }}
//                                 >
//                                     {[2025].map((year) => (
//                                         <MenuItem key={year} value={year}>{year}</MenuItem>
//                                     ))}
//                                 </Select>
//                             </FormControl>
//                             <Box>
//                                 <Typography variant="body2" color="text.secondary">
//                                     Showing holidays for {holidayYear}
//                                 </Typography>
//                             </Box>
//                         </Box>

//                         {loadingHolidays ? (
//                             <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
//                                 <CircularProgress />
//                             </Box>
//                         ) : holidayError ? (
//                             <Alert severity="error" sx={{ mb: 2 }}>
//                                 {holidayError}
//                             </Alert>
//                         ) : (
//                             <>
//                                 {holidays.length > 0 ? (
//                                     <TableContainer component={Paper} sx={{ borderRadius: '8px', boxShadow: 2 }}>
//                                         <Table>
//                                             <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
//                                                 <TableRow>
//                                                     <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
//                                                     <TableCell sx={{ fontWeight: 'bold' }}>Day</TableCell>
//                                                     <TableCell sx={{ fontWeight: 'bold' }}>Holiday Name</TableCell>
//                                                     <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
//                                                 </TableRow>
//                                             </TableHead>
//                                             <TableBody>
//                                                 {holidays
//                                                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                                                     .map((holiday) => (
//                                                         <TableRow key={holiday.id} hover>
//                                                             <TableCell>{formatDate(holiday.date)}</TableCell>
//                                                             <TableCell>{getDayOfWeek(holiday.date)}</TableCell>
//                                                             <TableCell>
//                                                                 <Typography variant="body2" fontWeight="medium">
//                                                                     {holiday.holiday_name}
//                                                                 </Typography>
//                                                             </TableCell>
//                                                             <TableCell>
//                                                                 <Chip
//                                                                     label={holiday.holiday_type || "General"}
//                                                                     size="small"
//                                                                     sx={{
//                                                                         backgroundColor: '#e3f2fd',
//                                                                         color: '#1565c0',
//                                                                         fontWeight: 500,
//                                                                     }}
//                                                                 />
//                                                             </TableCell>
//                                                         </TableRow>
//                                                     ))}
//                                             </TableBody>
//                                         </Table>
//                                         <TablePagination
//                                             rowsPerPageOptions={[5, 10, 25]}
//                                             component="div"
//                                             count={holidays.length}
//                                             rowsPerPage={rowsPerPage}
//                                             page={page}
//                                             onPageChange={handlePageChange}
//                                             onRowsPerPageChange={handleRowsPerPageChange}
//                                         />
//                                     </TableContainer>
//                                 ) : (
//                                     <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 6 }}>
//                                         <WbSunnyIcon sx={{ fontSize: 60, color: '#9e9e9e' }} />
//                                         <Typography variant="h6" color="text.secondary">
//                                             No holidays found
//                                         </Typography>
//                                         <Typography variant="body2" color="text.secondary">
//                                             There are no holidays listed for {holidayYear}
//                                         </Typography>
//                                     </Box>
//                                 )}
//                             </>
//                         )}
//                     </DialogContent>
//                     <Box
//                         sx={{
//                             display: 'flex',
//                             justifyContent: 'flex-end',
//                             p: 3,
//                             background: '#f8f9fa',
//                             borderTop: '1px solid #eee',
//                             borderBottomLeftRadius: '16px',
//                             borderBottomRightRadius: '16px',
//                         }}
//                     >
//                         <Button
//                             onClick={handleHolidaysListClose}
//                             variant="contained"
//                             sx={{
//                                 borderRadius: 8,
//                                 px: 3,
//                                 py: 1,
//                                 backgroundColor: '#9c27b0',
//                                 '&:hover': {
//                                     backgroundColor: '#7b1fa2'
//                                 }
//                             }}
//                         >
//                             Close
//                         </Button>
//                     </Box>
//                 </Dialog>


//                 <Modal
//                     open={isLeaveBalanceButtonOpen}
//                     onClose={() => {
//                         setIsLeaveBalanceButtonOpen(false);
//                         setError(null);
//                     }}
//                 >

//                     <Box
//                         sx={{
//                             position: 'absolute',
//                             top: '50%',
//                             left: '50%',
//                             transform: 'translate(-50%, -50%)',
//                             width: { xs: '90%', sm: 700, md: 800 },
//                             maxHeight: '90vh',
//                             overflowY: 'auto',
//                             bgcolor: 'background.paper',
//                             boxShadow: 24,
//                             borderRadius: 2,
//                             p: 4,
//                             outline: 'none',
//                         }}
//                     >

//                         <Card sx={{ boxShadow: 'none', borderRadius: 2 }}>
//                             <CardContent sx={{ p: 0 }}>
//                                 <Typography variant="h5" sx={{ mb: 3, color: '#1976d2', fontWeight: 'bold' }}>
//                                     Leave Balance Overview
//                                 </Typography>

//                                 {loading && (
//                                     <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
//                                         <CircularProgress />
//                                     </Box>
//                                 )}

//                                 {error && (
//                                     <Alert severity="error" sx={{ mb: 2 }}>
//                                         {error}
//                                     </Alert>
//                                 )}

//                                 {!loading && !error && leaveData.length === 0 && (
//                                     <Alert severity="info">No leave balance data available.</Alert>
//                                 )}

//                                 {!loading && !error && leaveData.length > 0 && (
//                                     <Grid container spacing={3}>
//                                         {leaveData.map((leave) => {
//                                             const progressValue =
//                                                 leave.allocated_days > 0
//                                                     ? (leave.used_days / leave.allocated_days) * 100
//                                                     : 0;
//                                             const displayType =
//                                                 leave.leave_type.charAt(0).toUpperCase() +
//                                                 leave.leave_type.slice(1);

//                                             return (
//                                                 <Grid item xs={12} sm={6} key={leave.leave_type_id}>
//                                                     <Box
//                                                         sx={{
//                                                             p: 2,
//                                                             borderRadius: 1,
//                                                             bgcolor: alpha('#1976d2', 0.05),
//                                                             height: '100%',
//                                                             display: 'flex',
//                                                             flexDirection: 'column',
//                                                             justifyContent: 'space-between',
//                                                         }}
//                                                     >
//                                                         <Typography variant="subtitle1" sx={{ mb: 1, color: '#1976d2', fontWeight: 'bold', fontSize: '18px' }}>
//                                                             {displayType}
//                                                         </Typography>
//                                                         <Box sx={{ mb: 2 }}>
//                                                             <Typography variant="body2" sx={{ mb: 0.5 }}>
//                                                                 <Box component="span" color={labelColor}>Total:</Box>{' '}
//                                                                 <Box component="span" sx={{ color: valueColor, fontWeight: 'bold' }}>
//                                                                     {leave.allocated_days} days
//                                                                 </Box>
//                                                             </Typography>
//                                                             <Typography variant="body2" sx={{ mb: 0.5 }}>
//                                                                 <Box component="span" color={labelColor}>Used:</Box>{' '}
//                                                                 <Box component="span" sx={{ color: valueColor, fontWeight: 'medium' }}>
//                                                                     {leave.used_days} days
//                                                                 </Box>
//                                                             </Typography>
//                                                             <Typography variant="body2">
//                                                                 <Box component="span" color={labelColor}>Remaining:</Box>{' '}
//                                                                 <Box component="span" sx={{ color: valueColor, fontWeight: 'medium' }}>
//                                                                     {leave.remaining} days
//                                                                 </Box>
//                                                             </Typography>
//                                                         </Box>
//                                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                                             <LinearProgress
//                                                                 variant="determinate"
//                                                                 value={progressValue}
//                                                                 sx={{
//                                                                     flexGrow: 1,
//                                                                     height: 10,
//                                                                     borderRadius: 5,
//                                                                     backgroundColor: alpha('#1976d2', 0.2),
//                                                                     '& .MuiLinearProgress-bar': {
//                                                                         backgroundColor: '#1976d2',
//                                                                     },
//                                                                 }}
//                                                             />
//                                                             <Typography
//                                                                 variant="caption"
//                                                                 color="text.secondary"
//                                                                 sx={{ minWidth: 'fit-content' }}
//                                                             >
//                                                                 {leave.used_days}/{leave.allocated_days} days
//                                                             </Typography>
//                                                         </Box>
//                                                     </Box>
//                                                 </Grid>
//                                             );
//                                         })}
//                                     </Grid>
//                                 )}
//                             </CardContent>
//                         </Card>
//                     </Box>
//                 </Modal>
//                 <Snackbar
//                     open={snackbar.open}
//                     autoHideDuration={6000}
//                     onClose={handleSnackbarClose}
//                     anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//                 >
//                     <Alert
//                         onClose={handleSnackbarClose}
//                         severity={snackbar.severity}
//                         variant="filled"
//                         sx={{ width: '100%' }}
//                     >
//                         {snackbar.message}
//                     </Alert>
//                 </Snackbar>
//             </Box>


//             <Modal
//                 open={openTokenExpirePopup}
//                 onClose={handleCloseTokenExpirePopup}
//                 aria-labelledby="token-expire-modal-title"
//                 aria-describedby="token-expire-modal-description"
//             >
//                 <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
//             </Modal>
//         </div>
//     );
// };

// export default EmployeeLeaveManagement;

import React, { useState, useEffect } from 'react';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import axios from 'axios';
import { styled } from '@mui/material/styles';
import {
    Box,
    Typography,
    Grid,
    Button,
    Paper,
    Divider,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContentText,
    DialogContent,
    TextField,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    MenuItem,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    InputLabel,
    Select,
    Snackbar,
    Alert,
    CircularProgress,
    Chip,
    Card,
    CardContent,
    Modal,
    LinearProgress,
    TablePagination,
    IconButton
} from '@mui/material';
import {
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as ChartTooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import { alpha } from '@mui/material/styles';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DateRangeIcon from '@mui/icons-material/DateRange';
import EventIcon from '@mui/icons-material/Event';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import { useNavigate } from 'react-router-dom';
import {
    BarChart,
    PendingActions,
    LocalHospital,
    Spa,
    KeyboardDoubleArrowRight,
    Public,
    Flag,
    FilterList,
    Search,
    Sort,
    ArrowDownward,
    ArrowUpward,
    CalendarMonth,
    Comment,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    FileDownloadOutlined as FileDownloadOutlinedIcon
} from "@mui/icons-material";
import TokenExpirePopup from '../../../components/TokenExpirePopup';
import { axiosInstance, localAxiosGet, localAxiosToken } from '../../../Axios/axios';
import { Loader } from '../../../components/loade';

const StyledGridItem = styled(Grid)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    marginRight: theme.spacing(3),
    '& .MuiRadio-root': {
        color: theme.palette.primary.main,
    },
    '& .MuiRadio-root.Mui-checked': {
        color: theme.palette.secondary.main,
    },
}));

const labelColor = 'text.secondary';
const valueColor = '#1976d2';

const EmployeeLeaveManagement = () => {
    const [isLeavesPopupOpen, setIsLeavesPopupOpen] = useState(false);
    const [isDaysFormOpen, setIsDaysFormOpen] = useState(false);
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [isHolidaysPopupOpen, setIsHolidaysPopupOpen] = useState(false);
    const [leaveType, setLeaveType] = useState('');
    const [showEndDate, setShowEndDate] = useState(false);
    const [leaveReason, setLeaveReason] = useState('');
    const [leaveReasonOtherFieldDisplay, setLeaveReasonOtherFieldDisplay] = useState(false);
    const [otherReason, setOtherReason] = useState('');
    const [comments, setComments] = useState('');
    const today = dayjs();
    const tomorrow = today.add(1, 'day');
    const [dateValidationMessage, setDateValidationMessage] = useState('');
    const [reportManager, setReportManager] = useState(localStorage.getItem('reportingmanagerId') || '');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate()
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });
    const [holidays, setHolidays] = useState([]);
    const [loadingHolidays, setLoadingHolidays] = useState(false);
    const [holidayYear, setHolidayYear] = useState(new Date().getFullYear());
    const [holidayError, setHolidayError] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [leaveBalance, setLeaveBalance] = useState([]);
    const [loadingLeaveBalance, setLoadingLeaveBalance] = useState(false);
    const [leaveBalanceError, setLeaveBalanceError] = useState('');
    const [totalLeaves, setTotalLeaves] = useState(0);
    const [casualLeaveBalance, setCasualLeaveBalance] = useState(0);
    const [sickLeaveBalance, setSickLeaveBalance] = useState(0);
    const [pendingRequests, setPendingRequests] = useState(0);
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [loadingLeaveTypes, setLoadingLeaveTypes] = useState(false);
    const [leaveTypesError, setLeaveTypesError] = useState('');
    const [managers, setManagers] = useState([]);
    const [loadingManagers, setLoadingManagers] = useState(false);
    const [managersError, setManagersError] = useState('');
    const [isMyLeavesPopupOpen, setIsMyLeavesPopupOpen] = useState(false);
    const [myLeaves, setMyLeaves] = useState([]);
    const [loadingMyLeaves, setLoadingMyLeaves] = useState(false);
    const [myLeavesError, setMyLeavesError] = useState('');
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [pageMyLeaves, setPageMyLeaves] = useState(0);
    const [rowsPerPageMyLeaves, setRowsPerPageMyLeaves] = useState(6);
    const [sortBy, setSortBy] = useState('start_date');
    const [sortOrder, setSortOrder] = useState('asc');
    const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
    const token = localStorage.getItem('accessToken');
    const reportingmanagerId = localStorage.getItem('reportingmanagerId');
    console.log('reportingmanagerId', reportingmanagerId);
    const [isLeaveBalancePopupOpen, setIsLeaveBalancePopupOpen] = useState(false);
    const [leaveBalanceData, setLeaveBalanceData] = useState([]);
    const [loadingLeaveBalanceData, setLoadingLeaveBalanceData] = useState(false);
    const accessToken = localStorage.getItem('accessToken');
    const [isLeaveBalanceButtonOpen, setIsLeaveBalanceButtonOpen] = useState(false);
    const [leaveData, setLeaveData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const currentYear = dayjs().year();
    const years = [currentYear - 2, currentYear - 1, currentYear];
    const [paginationInfo, setPaginationInfo] = useState({
        totalRecords: 0,
        totalPages: 1,
        currentPage: 1,
        limit: 10
    });

    const fetchLeaveBalanceData = async () => {
        setLoadingLeaveBalanceData(true);
        try {
            const userId = localStorage.getItem('userId');
            if (!userId) {
                throw new Error('User ID not found in localStorage');
            }

            const response = await axiosInstance(localAxiosGet(`/organization/getEmployeeLeaveBalance?user_id=${userId}`, token));

            if (response.data && response.data.statusCode === 200) {
                console.log('Leave balance response:', response.data);
                if (Array.isArray(response.data.message)) {
                    const transformedData = response.data.message.map(leaveType => ({
                        name: leaveType.leave_type,
                        total: leaveType.max_days,
                        remaining: leaveType.balance_days,
                        used: leaveType.max_days - leaveType.balance_days
                    }));
                    setLeaveBalanceData(transformedData);
                } else if (response.data.message && typeof response.data.message === 'object') {
                    const transformedData = [];
                    if (response.data.message.leave_types && Array.isArray(response.data.message.leave_types)) {
                        response.data.message.leave_types.forEach(leaveType => {
                            transformedData.push({
                                name: leaveType.leave_type,
                                total: leaveType.max_days,
                                remaining: leaveType.balance_days,
                                used: leaveType.max_days - leaveType.balance_days
                            });
                        });
                    }
                    if (transformedData.length === 0 && response.data.message.total_leaves !== undefined) {
                        transformedData.push({
                            name: "Total Leaves",
                            total: response.data.message.total_leaves,
                            remaining: response.data.message.total_leaves - (response.data.message.pending_leaves || 0),
                            used: response.data.message.pending_leaves || 0
                        });
                    }
                    setLeaveBalanceData(transformedData);
                } else {
                    throw new Error('Unexpected response format from leave balance API');
                }
            } else {
                throw new Error(response.data.message?.msg || 'Failed to fetch leave balance');
            }
        } catch (error) {
            console.error('Error fetching leave balance data:', error);
            setSnackbar({
                open: true,
                message: 'Failed to load leave balance data. Please try again.',
                severity: 'error'
            });
            setLeaveBalanceData([]);
        } finally {
            setLoadingLeaveBalanceData(false);
        }
    };

    useEffect(() => {
        if (isLeaveBalancePopupOpen) {
            fetchLeaveBalanceData();
        }
    }, [isLeaveBalancePopupOpen]);

    useEffect(() => {
        fetchLeaveBalance();
        fetchLeaveTypes();

    }, []);

    useEffect(() => {
        if (isHolidaysPopupOpen) {
            fetchHolidays();
        }
    }, [isHolidaysPopupOpen, holidayYear]);

    useEffect(() => {
        if (isMyLeavesPopupOpen) {
            fetchMyLeaves();
        }
    }, [isMyLeavesPopupOpen, selectedYear, selectedMonth, sortBy, sortOrder, pageMyLeaves, token]);

    const fetchMyLeaves = async () => {
        setLoadingMyLeaves(true);
        setMyLeavesError('');
        try {
            const userId = getLocalStorageUserID();
            if (!userId) {
                throw new Error('User ID not found in localStorage');
            }

            const response = await axiosInstance(localAxiosGet(`/organization/getLeaveHistoryByEmployee?year=${selectedYear}&user_id=${userId}&month=${selectedMonth}&page=${pageMyLeaves + 1}&limit=${rowsPerPageMyLeaves}`, token));

            if (response.data.statusCode === 200) {

                const paginationInfo = response.data.result || {};
                const leaveHistory = paginationInfo.leaveHistory || [];

                const formattedLeaves = leaveHistory.map((leave, index) => ({
                    id: index + 1,
                    start_date: leave.start_date,
                    end_date: leave.end_date,
                    leave_type: leave.leave_type,
                    status: leave.status.toLowerCase(),
                    reason: leave.reason,
                    comments: leave.comment || 'No comments provided'
                }));

                let sortedData = [...formattedLeaves];
                sortedData.sort((a, b) => {
                    if (sortBy === 'start_date') {
                        const dateA = new Date(a.start_date);
                        const dateB = new Date(b.start_date);
                        return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
                    } else if (sortBy === 'leave_type') {
                        return sortOrder === 'asc'
                            ? a.leave_type.localeCompare(b.leave_type)
                            : b.leave_type.localeCompare(a.leave_type);
                    } else if (sortBy === 'status') {
                        return sortOrder === 'asc'
                            ? a.status.localeCompare(b.status)
                            : b.status.localeCompare(a.status);
                    }
                    return 0;
                });

                setMyLeaves(sortedData);


                setPaginationInfo({
                    totalRecords: parseInt(paginationInfo.totalRecords || 0),
                    totalPages: parseInt(paginationInfo.totalPages || 1),
                    currentPage: parseInt(paginationInfo.currentPage || 1),
                    limit: parseInt(paginationInfo.limit || 10)
                });
            } else {
                throw new Error(response.data.message || 'Failed to fetch leave history');
            }
        } catch (error) {
            console.error('Error fetching leave history:', error);
            setMyLeavesError('Failed to load leave history. Please try again.');
            setMyLeaves([]);
        } finally {
            setLoadingMyLeaves(false);
        }
    };

    const fetchLeaveTypes = async () => {
        setLoadingLeaveTypes(true);
        setLeaveTypesError('');
        try {
            const token = localStorage.getItem('accessToken');
            const organizationId = localStorage.getItem('organizationId');
            if (!organizationId) {
                throw new Error('Organization ID not found in localStorage');
            }

            const response = await axiosInstance(localAxiosGet(`/organization/getAllLeaveTypes?organization_id=${organizationId}`, token))

            if (response.data.statusCode === 200) {
                setLeaveTypes(response.data.message.leaveTypes);
            } else {
                throw new Error(response.data.message?.msg || 'Failed to fetch leave types');
            }
        } catch (error) {
            console.error('Error fetching leave types:', error);
            setLeaveTypesError('Failed to load leave types. Please try again.');
            // if (error.response && (error.response.status === 403 || error.response.statusCode === 403)) {
            //     setOpenTokenExpirePopup(true);
            // }
        } finally {
            setLoadingLeaveTypes(false);
        }
    };

    const fetchLeaveBalance = async () => {
        setLoadingLeaveBalance(true);
        setLeaveBalanceError('');
        try {
            const userId = localStorage.getItem('userId');
            if (!userId) {
                throw new Error('User ID not found in localStorage');
            }

            const response = await axiosInstance(localAxiosGet(`/organization/getEmployeeLeaveBalance?user_id=${userId}`, token))
            if (response.data && response.data.statusCode === 200) {
                setLeaveBalance(response.data.message);
                setTotalLeaves(response.data.message.total_leaves);
                setPendingRequests(response.data.message.pending_leaves);
            } else {
                throw new Error(response.data.message?.msg || 'Failed to fetch leave balance');
            }
        } catch (error) {
            console.error('Error fetching leave balance:', error);
            setLeaveBalanceError('Failed to load leave balance. Please try again.');
        } finally {
            setLoadingLeaveBalance(false);
        }
    };

    const fetchHolidays = async () => {
        setLoadingHolidays(true);
        setHolidayError('');
        try {
            const organizationId = localStorage.getItem('organizationId');
            const locationId = localStorage.getItem('locationId');
            const response = await axiosInstance(localAxiosGet(`/organization/getAllHolidaysByYearAndMonth?year=${holidayYear}&organization_id=${organizationId}&location_id=${locationId}`, token))
            if (response.data && response.data.statusCode === 200) {
                setHolidays(response.data.message.holidays);
            } else {
                throw new Error(response.data.message?.msg || 'Failed to fetch holidays');
            }
        } catch (error) {
            console.error('Error fetching holidays:', error);
            setHolidayError('Failed to load holidays. Please try again.');
            setHolidays([]);
        } finally {
            setLoadingHolidays(false);
        }
    };

    const handleDownloadCalendar = async () => {
        try {
            const token = localStorage.getItem('accessToken');
            const orgId = localStorage.getItem('organizationId');
            const locId = localStorage.getItem('locationId');
            const currentYear = dayjs().year();

            if (!token || !orgId) {
                setSnackbar("Authentication token or organization ID not found", "error");
                return;
            }

            const endpoint = `/organization/getHolidayListPDF?year=${currentYear}&location_id=${locId}&organization_id=${orgId}`;

            const response = await axiosInstance({
                ...localAxiosGet(endpoint, token),
                responseType: 'blob'
            });

            if (!(response.data instanceof Blob)) {
                throw new Error('Response data is not a Blob');
            }

            const contentType = response.headers['content-type'] || 'application/pdf';

            const extension = 'pdf';
            const filename = `holiday_calendar_${currentYear}.${extension}`;

            const contentDisposition = response.headers['content-disposition'];
            const finalFilename = contentDisposition && contentDisposition.match(/filename="?(.+)"?/)
                ? contentDisposition.match(/filename="?(.+)"?/)[1]
                : filename;

            const blob = new Blob([response.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = finalFilename;
            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 100);

            setSnackbar("Download started successfully!", "success");


        } catch (error) {
            console.error('Download failed:', error);
            setSnackbar("Failed to download. Please try again", "error");
        }
    };

    // const handleCloseTokenExpirePopup = () => {
    //     setOpenTokenExpirePopup(false);
    //     navigate('/');
    // };

    const handleLeaveTypeSelection = (event) => {
        const selectedLeaveType = event.target.value;
        setLeaveType(selectedLeaveType);
    };

    const handleLeavesPopup = () => {
        setIsLeavesPopupOpen(true);
    }

    const handleLeavesPopupClose = () => {
        setIsLeavesPopupOpen(false);
        resetForm();
    }

    const resetForm = () => {
        setLeaveType('');
        setIsDaysFormOpen(false);
        setLeaveReason('');
        setLeaveReasonOtherFieldDisplay(false);
        setOtherReason('');
        setComments('');
        setStartDate(dayjs());
        setEndDate(dayjs());
        setShowEndDate(false);
    }

    const handleHolidaysList = () => {
        setIsHolidaysPopupOpen(true);
    }

    const handleHolidaysListClose = () => {
        setIsHolidaysPopupOpen(false);
    }

    const handleYearChange = (event) => {
        setHolidayYear(event.target.value);
        setPage(0);
    };

    const handleSnackbarClose = () => {
        setSnackbar({ ...snackbar, open: false });
    }

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getLocalStorageUserID = () => {
        const userID = localStorage.getItem('userId');
        return userID ? userID : null;
    };

    const handleRequestSort = (event, property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';
        setSortBy(property);
        setSortOrder(isAsc ? 'desc' : 'asc');
    };

    const handleYearMonthChange = (event) => {
        if (event.target.name === 'year') {
            setSelectedYear(parseInt(event.target.value));
        } else {
            setSelectedMonth(parseInt(event.target.value));
        }
        setPageMyLeaves(0);
    };

    const handleSubmitRequest = async () => {
        if (!leaveType) {
            setSnackbar({ open: true, message: 'Please select a leave type', severity: 'error' });
            return;
        }

        if (!reportManager) {
            setSnackbar({ open: true, message: 'Reporting manager information is missing', severity: 'error' });
            return;
        }
        if (!leaveReason) {
            setSnackbar({ open: true, message: 'Please provide reason for leave', severity: 'error' });
            return;
        }

        const formattedStartDate = startDate.format('YYYY-MM-DD');
        const formattedEndDate = endDate.format('YYYY-MM-DD');
        const organizationId = localStorage.getItem('organizationId');
        const locationId = localStorage.getItem('locationId');

        if (!organizationId) {
            setSnackbar({ open: true, message: 'Organization ID not found', severity: 'error' });
            return;
        }

        const leaveRequest = {
            user_id: getLocalStorageUserID(),
            start_date: formattedStartDate,
            end_date: formattedEndDate,
            organization_id: parseInt(organizationId, 10),
            location_id: locationId,
            leave_type_id: parseInt(leaveType, 10),
            report_manager_id: reportManager,
            leave_duration_type: "FULL_DAY",
            reason: leaveReason
        };

        console.log('Using report_manager_id:', reportManager);
        console.log('Leave Request Payload:', leaveRequest);

        setIsSubmitting(true);

        try {
            const response = await axiosInstance(localAxiosToken('/organization/createLeave', leaveRequest));

            if (response.data && response.data.statusCode === 200) {
                setSnackbar({ open: true, message: 'Leave request submitted successfully', severity: 'success' });
                setTimeout(() => {
                    handleLeavesPopupClose();
                    fetchLeaveBalance();
                    if (isMyLeavesPopupOpen) {
                        const newLeave = {
                            id: myLeaves.length + 1,
                            start_date: formattedStartDate,
                            end_date: formattedEndDate,
                            leave_type: leaveTypes.find(lt => lt.id.toString() === leaveType)?.leave_type || 'Unknown',
                            status: 'pending',
                            reason: comments || 'No reason provided',
                            comments: 'Waiting for approval'
                        };
                        setMyLeaves(prev => [newLeave, ...prev]);
                    }
                }, 1500);
            } else {
                throw new Error(response.data.message?.msg || 'Failed to submit leave request');
            }
        } catch (error) {
            console.error('Error submitting leave request:', error);
            let errorMessage = 'Failed to submit leave request. Please try again.';
            if (error.response && error.response.data) {
                const { statusCode, message } = error.response.data;
                if (statusCode === 400 && message) {
                    errorMessage = message;
                } else if (message && typeof message === 'string') {
                    errorMessage = message;
                } else if (message && typeof message === 'object' && message.msg) {
                    errorMessage = message.msg;
                }
            } else if (error.message) {
                errorMessage = error.message;
            }
            setSnackbar({
                open: true,
                message: errorMessage,
                severity: 'error'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const getDayOfWeek = (dateString) => {
        const date = new Date(dateString);
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return days[date.getDay()];
    };

    const getMinDateForSickLeave = () => {
        const today = dayjs();
        const prevMonth = today.subtract(1, 'month');
        // Set to 1st day of previous month
        return prevMonth.startOf('month');
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'approved':
                return 'success';
            case 'rejected':
                return 'error';
            case 'pending':
                return 'warning';
            default:
                return 'default';
        }
    };

    const getStatusIcon = (status) => {
        switch (status?.toLowerCase()) {
            case 'approved':
                return <Flag />;
            case 'rejected':
                return null;
            case 'pending':
                return <PendingActions />;
            default:
                return null;
        }
    };

    const fetchLeaveTypeBalance = async () => {
        setLoading(true);
        setError(null);
        const userId = localStorage.getItem('userId');
        try {
            const response = await axiosInstance(localAxiosGet(`/organization/getAllLeaveTypesByEmpId?user_id=${userId}`, accessToken));
            if (response.data.statusCode === 200 && response.data.status === 'SUCCESS') {
                setLeaveData(response.data.message.leaveTypesWithBalance);
            } else {
                setError(response.data.message || 'Failed to fetch leave balance.');
            }
        } catch (e) {
            setError('Error fetching data: ' + e.message);
            setLeaveData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleLeaveBalanceButton = async () => {
        await fetchLeaveTypeBalance();
        setIsLeaveBalanceButtonOpen(true);
    };

    const handlePageChangeMyLeaves = (newPage) => {
        setPageMyLeaves(newPage);
    };

    const handleHolidaysCalendarDownload = () => {

    }
    return (
        <div>
            <Box sx={{ paddingRight: 3, pt: 2, height: '80vh' }}>
                <Typography variant="h4" fontWeight="bold" sx={{ mb: 4 }}>
                    Manage Leaves
                </Typography>
                <Grid container spacing={3} sx={{ mb: 4 }}>
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper sx={{ p: 2, bgcolor: '#fff0f6' }}>
                            <Typography variant="h6">Total Leaves</Typography>
                            <Typography variant="h4" fontWeight="bold">
                                {loadingLeaveBalance ? (
                                    <CircularProgress size={30} />
                                ) : (
                                    totalLeaves
                                )}
                            </Typography>
                            <BarChart sx={{ color: '#ff6b6b', fontSize: 40 }} />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper sx={{ p: 2, bgcolor: '#e6fcf5' }}>
                            <Typography variant="h6">Remaining Leaves</Typography>
                            <Typography variant="h4" fontWeight="bold">
                                {loadingLeaveBalance ? (
                                    <CircularProgress size={30} />
                                ) : (
                                    leaveBalance.remaining_leaves
                                )}
                            </Typography>
                            <Spa sx={{ color: '#38d9a9', fontSize: 40 }} />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper sx={{ p: 2, bgcolor: '#f0f4ff' }}>
                            <Typography variant="h6">Pending Requests</Typography>
                            <Typography variant="h4" fontWeight="bold">{pendingRequests}</Typography>
                            <PendingActions sx={{ color: '#ffd43b', fontSize: 40 }} />
                        </Paper>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} lg={10}>
                        <Box display="flex" flexDirection="row" gap={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => setIsMyLeavesPopupOpen(true)}

                                sx={{
                                    flex: 1,
                                    padding: 2,
                                    textAlign: "left",
                                    backgroundColor: '#6a1b9a',
                                    '&:hover': {
                                        backgroundColor: '#4a148c'
                                    }
                                }}
                                endIcon={<KeyboardDoubleArrowRight sx={{ fontSize: "2.5rem", width: 30, height: 30 }} />}
                            >
                                <Typography>My Leaves</Typography>
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleLeavesPopup}
                                sx={{
                                    flex: 1,
                                    padding: 2,
                                    textAlign: "left",
                                }}
                                endIcon={<KeyboardDoubleArrowRight sx={{ fontSize: "2.5rem", width: 30, height: 30 }} />}
                            >
                                <Typography>Apply for Leave</Typography>
                            </Button>
                            <Button
                                variant="contained"
                                sx={{ flex: 1, padding: 2, backgroundColor: '#b841d0' }}
                                onClick={handleHolidaysList}
                                endIcon={<KeyboardDoubleArrowRight sx={{ fontSize: "2.5rem", width: 30, height: 30 }} />}
                            >
                                <Typography>Holidays List</Typography>
                            </Button>
                            <Button
                                variant="contained"
                                sx={{ flex: 1, padding: 2, backgroundColor: '#b841d0' }}
                                onClick={handleLeaveBalanceButton}
                                endIcon={<KeyboardDoubleArrowRight sx={{ fontSize: "2.5rem", width: 30, height: 30 }} />}
                            >
                                <Typography>Leave Balance</Typography>
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
                <Dialog
                    open={isMyLeavesPopupOpen}
                    onClose={() => setIsMyLeavesPopupOpen(false)}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: '16px',
                        },
                    }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(90deg, #6a1b9a 0%, #8e24aa 100%)',
                            p: 3,
                            color: 'white',
                            borderTopLeftRadius: '16px',
                            borderTopRightRadius: '16px',
                        }}
                    >
                        <Typography variant="h5" fontWeight="500">
                            My Leave History
                        </Typography>
                    </Box>
                    <DialogContent sx={{ p: 3 }}>
                        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', gap: 2 }}>

                                <FormControl sx={{ minWidth: 120 }}>
                                    <InputLabel id="year-select-label">Year</InputLabel>
                                    <Select
                                        labelId="year-select-label"
                                        value={selectedYear}
                                        onChange={handleYearMonthChange}
                                        label="Year"
                                        sx={{ borderRadius: '8px' }}
                                    >
                                        {years.map((year) => (
                                            <MenuItem key={year} value={year}>{year}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl sx={{ minWidth: 120 }}>
                                    <InputLabel id="month-select-label">Month</InputLabel>
                                    <Select
                                        labelId="month-select-label"
                                        value={selectedMonth}
                                        onChange={handleYearMonthChange}
                                        label="month"
                                        sx={{ borderRadius: '8px' }}
                                    >
                                        {[
                                            { value: 1, label: 'January' },
                                            { value: 2, label: 'February' },
                                            { value: 3, label: 'March' },
                                            { value: 4, label: 'April' },
                                            { value: 5, label: 'May' },
                                            { value: 6, label: 'June' },
                                            { value: 7, label: 'July' },
                                            { value: 8, label: 'August' },
                                            { value: 9, label: 'September' },
                                            { value: 10, label: 'October' },
                                            { value: 11, label: 'November' },
                                            { value: 12, label: 'December' }
                                        ]
                                            .filter(month =>
                                                selectedYear < new Date().getFullYear() ||
                                                month.value <= new Date().getMonth() + 1
                                            )
                                            .map((month) => (
                                                <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box>
                        {loadingMyLeaves ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                                <CircularProgress />
                            </Box>
                        ) : myLeavesError ? (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {myLeavesError}
                            </Alert>
                        ) : (
                            <>
                                {myLeaves.length > 0 ? (
                                    <Grid container spacing={2}>
                                        {myLeaves.map((leave, index) => (
                                            <Grid item xs={12} sm={6} md={4} key={leave.id || index}>
                                                <Card
                                                    sx={{
                                                        height: '100%',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        boxShadow: 3,
                                                        borderRadius: 2,
                                                        transition: 'transform 0.2s, box-shadow 0.2s',
                                                        '&:hover': {
                                                            transform: 'translateY(-4px)',
                                                            boxShadow: 6,
                                                        }
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            p: 2,
                                                            backgroundColor: leave.leave_type?.includes('Sick') ? '#ffebee' :
                                                                leave.leave_type?.includes('Casual') ? '#e8f5e9' :
                                                                    leave.leave_type?.includes('Paid') ? '#e3f2fd' : '#f3e5f5',
                                                            borderBottom: '1px solid #eee'
                                                        }}
                                                    >
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <Chip
                                                                label={leave.leave_type || "N/A"}
                                                                size="small"
                                                                sx={{
                                                                    backgroundColor: leave.leave_type?.includes('Sick') ? '#ffebee' :
                                                                        leave.leave_type?.includes('Casual') ? '#e8f5e9' :
                                                                            leave.leave_type?.includes('Paid') ? '#e3f2fd' : '#f3e5f5',
                                                                    color: leave.leave_type?.includes('Sick') ? '#c62828' :
                                                                        leave.leave_type?.includes('Casual') ? '#2e7d32' :
                                                                            leave.leave_type?.includes('Paid') ? '#1565c0' : '#6a1b9a',
                                                                    fontWeight: 500,
                                                                    border: '1px solid',
                                                                    borderColor: leave.leave_type?.includes('Sick') ? '#ef9a9a' :
                                                                        leave.leave_type?.includes('Casual') ? '#a5d6a7' :
                                                                            leave.leave_type?.includes('Paid') ? '#90caf9' : '#ce93d8',
                                                                }}
                                                            />
                                                            <Chip
                                                                icon={getStatusIcon(leave.status)}
                                                                label={leave.status || "Pending"}
                                                                size="small"
                                                                color={getStatusColor(leave.status)}
                                                                variant={leave.status === 'approved' ? "filled" : "outlined"}
                                                                sx={{ fontWeight: 500 }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                    <CardContent sx={{ flexGrow: 1, p: 2 }}>
                                                        <Box sx={{ mb: 2 }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                                <CalendarMonth sx={{ fontSize: 18, color: '#666', mr: 1 }} />
                                                                <Typography variant="subtitle2" color="text.secondary">
                                                                    Date Range
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ pl: 3.5 }}>
                                                                <Typography variant="body2" fontWeight="medium">
                                                                    {formatDate(leave.start_date)}
                                                                </Typography>
                                                                {leave.start_date !== leave.end_date && (
                                                                    <Typography variant="body2" color="text.secondary">
                                                                        to {formatDate(leave.end_date)}
                                                                    </Typography>
                                                                )}
                                                                <Typography variant="caption" color="text.secondary">
                                                                    {leave.start_date && getDayOfWeek(leave.start_date)}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ mb: 2 }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                                <Search sx={{ fontSize: 18, color: '#666', mr: 1 }} />
                                                                <Typography variant="subtitle2" color="text.secondary">
                                                                    Reason
                                                                </Typography>
                                                            </Box>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    pl: 3.5,
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    display: '-webkit-box',
                                                                    WebkitLineClamp: 2,
                                                                    WebkitBoxOrient: 'vertical'
                                                                }}
                                                            >
                                                                {leave.reason || 'N/A'}
                                                            </Typography>
                                                        </Box>
                                                        <Box>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                                <Comment sx={{ fontSize: 18, color: '#666', mr: 1 }} />
                                                                <Typography variant="subtitle2" color="text.secondary">
                                                                    Comments
                                                                </Typography>
                                                            </Box>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    pl: 3.5,
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    display: '-webkit-box',
                                                                    WebkitLineClamp: 2,
                                                                    WebkitBoxOrient: 'vertical'
                                                                }}
                                                            >
                                                                {leave.comments || leave.description || 'N/A'}
                                                            </Typography>
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                ) : (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 6 }}>
                                        <EventIcon sx={{ fontSize: 60, color: '#9e9e9e' }} />
                                        <Typography variant="h6" color="text.secondary">
                                            No leave records found
                                        </Typography>
                                    </Box>
                                )}
                                {myLeaves.length > 0 && (
                                    <Box sx={{ mt: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #e0e0e0', pt: 2 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                Showing page {paginationInfo.currentPage} of {paginationInfo.totalPages}
                                                ({paginationInfo.totalRecords} total records)
                                            </Typography>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    disabled={pageMyLeaves <= 0}
                                                    onClick={() => handlePageChangeMyLeaves(pageMyLeaves - 1)}
                                                    sx={{
                                                        minWidth: 'auto',
                                                        p: '4px 8px',
                                                        borderColor: '#6a1b9a',
                                                        color: '#6a1b9a',
                                                        '&:hover': { bgcolor: alpha('#6a1b9a', 0.1) }
                                                    }}
                                                >
                                                    <KeyboardArrowLeft fontSize="small" />
                                                </Button>
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    disabled={pageMyLeaves >= paginationInfo.totalPages - 1}
                                                    onClick={() => handlePageChangeMyLeaves(pageMyLeaves + 1)}
                                                    sx={{
                                                        minWidth: 'auto',
                                                        p: '4px 8px',
                                                        borderColor: '#6a1b9a',
                                                        color: '#6a1b9a',
                                                        '&:hover': { bgcolor: alpha('#6a1b9a', 0.1) }
                                                    }}
                                                >
                                                    <KeyboardArrowRight fontSize="small" />
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                )}
                            </>
                        )}
                    </DialogContent>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            p: 3,
                            background: '#f8f9fa',
                            borderTop: '1px solid #eee',
                            borderBottomLeftRadius: '16px',
                            borderBottomRightRadius: '16px',
                        }}
                    >
                        <Button
                            onClick={() => setIsMyLeavesPopupOpen(false)}
                            variant="contained"
                            sx={{
                                borderRadius: 8,
                                px: 3,
                                py: 1,
                                backgroundColor: '#6a1b9a',
                                '&:hover': {
                                    backgroundColor: '#4a148c'
                                }
                            }}
                        >
                            Close
                        </Button>
                    </Box>
                </Dialog>
                <Dialog
                    open={isLeaveBalancePopupOpen}
                    onClose={() => setIsLeaveBalancePopupOpen(false)}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: '16px',
                        },
                    }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(90deg, #00796b 0%, #009688 100%)',
                            p: 3,
                            color: 'white',
                            borderTopLeftRadius: '16px',
                            borderTopRightRadius: '16px',
                        }}
                    >
                        <Typography variant="h5" fontWeight="500">
                            My Leave Balance
                        </Typography>
                    </Box>
                    <DialogContent sx={{ p: 3 }}>
                        {loadingLeaveBalanceData ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                                <CircularProgress />
                            </Box>
                        ) : leaveBalanceData.length === 0 ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 6 }}>
                                <EventIcon sx={{ fontSize: 60, color: '#9e9e9e' }} />
                                <Typography variant="h6" color="text.secondary">
                                    No leave balance data found
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    There is no leave balance information available at this time.
                                </Typography>
                            </Box>
                        ) : (
                            <>
                                <Box sx={{ height: 300, mb: 4 }}>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <BarChart
                                            data={leaveBalanceData}
                                            margin={{
                                                top: 20,
                                                right: 30,
                                                left: 20,
                                                bottom: 5,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="name" />
                                            <YAxis />
                                            <ChartTooltip />
                                            <Legend />
                                            <Bar dataKey="total" name="Total Allocation" fill="#00796b" />
                                            <Bar dataKey="used" name="Used" fill="#f57c00" />
                                            <Bar dataKey="remaining" name="Remaining" fill="#1976d2" />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </Box>
                                <Grid container spacing={3}>
                                    {leaveBalanceData.map((item, index) => (
                                        <Grid item xs={12} sm={6} md={4} key={index}>
                                            <Card sx={{ boxShadow: 2, borderRadius: 2 }}>
                                                <CardContent>
                                                    <Typography variant="h6" sx={{
                                                        mb: 2,
                                                        color: item.name.toLowerCase().includes('casual') ? '#2e7d32' :
                                                            item.name.toLowerCase().includes('sick') ? '#c62828' :
                                                                item.name.toLowerCase().includes('total') ? '#1976d2' : '#1565c0'
                                                    }}>
                                                        {item.name}
                                                    </Typography>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                        <Typography variant="body2" color="text.secondary">
                                                            Total Allocation
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="bold">
                                                            {item.total} days
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                                        <Typography variant="body2" color="text.secondary">
                                                            Used
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="bold">
                                                            {item.used} days
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                                        <Typography variant="body2" color="text.secondary">
                                                            Remaining
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="bold">
                                                            {item.remaining} days
                                                        </Typography>
                                                    </Box>
                                                    <LinearProgress
                                                        variant="determinate"
                                                        value={(item.used / (item.total || 1)) * 100}
                                                        sx={{
                                                            height: 8,
                                                            borderRadius: 4,
                                                            backgroundColor: alpha(
                                                                item.name.toLowerCase().includes('casual') ? '#2e7d32' :
                                                                    item.name.toLowerCase().includes('sick') ? '#c62828' :
                                                                        item.name.toLowerCase().includes('total') ? '#1976d2' : '#1565c0',
                                                                0.2
                                                            ),
                                                            '& .MuiLinearProgress-bar': {
                                                                backgroundColor: item.name.toLowerCase().includes('casual') ? '#2e7d32' :
                                                                    item.name.toLowerCase().includes('sick') ? '#c62828' :
                                                                        item.name.toLowerCase().includes('total') ? '#1976d2' : '#1565c0',
                                                            }
                                                        }}
                                                    />
                                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, textAlign: 'right' }}>
                                                        {item.total ? ((item.used / item.total) * 100).toFixed(1) : 0}% used
                                                    </Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </>
                        )}
                    </DialogContent>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            p: 3,
                            background: '#f8f9fa',
                            borderTop: '1px solid #eee',
                            borderBottomLeftRadius: '16px',
                            borderBottomRightRadius: '16px',
                        }}
                    >
                        <Button
                            onClick={() => setIsLeaveBalancePopupOpen(false)}
                            variant="contained"
                            sx={{
                                borderRadius: 8,
                                px: 3,
                                py: 1,
                                backgroundColor: '#00796b',
                                '&:hover': {
                                    backgroundColor: '#00695c'
                                }
                            }}
                        >
                            Close
                        </Button>
                    </Box>
                </Dialog>
                <Dialog
                    open={isLeavesPopupOpen}
                    onClose={handleLeavesPopupClose}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: '16px',
                        },
                    }}
                >
                    <DialogTitle sx={{
                        background: 'linear-gradient(45deg, #1976d2 30%, #1565c0 90%)',
                        color: 'white',
                        p: 3,
                    }}>
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Apply for Leave
                        </Typography>
                        <Typography variant="subtitle2" sx={{ mt: 1, opacity: 0.8 }}>
                            Fill in the details below to submit your leave request
                        </Typography>
                    </DialogTitle>
                    <DialogContent sx={{ p: 3 }}>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Leave Type</InputLabel>
                                    <Select
                                        value={leaveType}
                                        label="Leave Type"
                                        onChange={handleLeaveTypeSelection}
                                        sx={{ borderRadius: '8px' }}
                                    >
                                        {loadingLeaveTypes ? (
                                            <MenuItem disabled>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <CircularProgress size={20} />
                                                    <Typography>Loading leave types...</Typography>
                                                </Box>
                                            </MenuItem>
                                        ) : leaveTypesError ? (
                                            <MenuItem disabled>
                                                <Typography color="error">{leaveTypesError}</Typography>
                                            </MenuItem>
                                        ) : (
                                            leaveTypes.map((type) => (
                                                <MenuItem key={type.id} value={type.id.toString()}>
                                                    {type.leave_type}
                                                </MenuItem>
                                            ))
                                        )}
                                    </Select>
                                    {leaveTypesError && (
                                        <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                                            {leaveTypesError}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Start Date"
                                        value={startDate}
                                        onChange={(newValue) => setStartDate(newValue)}
                                        format="DD-MM-YYYY"
                                        minDate={(() => {
                                            const selectedLeaveType = leaveTypes.find(type => type.id.toString() === leaveType);
                                            const leaveTypeName = selectedLeaveType?.leave_type?.toLowerCase().trim();
                                            
                                            if (leaveTypeName === 'casual leave') {
                                                return dayjs();
                                            } else if (leaveTypeName === 'sick leave' || leaveTypeName === 'loss of pay') {
                                                return getMinDateForSickLeave();
                                            }
                                            return undefined;
                                        })()}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px' } },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="End Date"
                                        value={endDate}
                                        onChange={(newValue) => setEndDate(newValue)}
                                        format="DD-MM-YYYY"
                                        minDate={(() => {
                                            const selectedLeaveType = leaveTypes.find(type => type.id.toString() === leaveType);
                                            const leaveTypeName = selectedLeaveType?.leave_type?.toLowerCase().trim();
                                            
                                            if (leaveTypeName === 'casual leave') {
                                                return dayjs();
                                            } else if (leaveTypeName === 'sick leave' || leaveTypeName === 'loss of pay') {
                                                return getMinDateForSickLeave();
                                            }
                                            return undefined;
                                        })()}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                sx: { '& .MuiOutlinedInput-root': { borderRadius: '8px' } },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    label="Reason"
                                    multiline
                                    rows={4}
                                    fullWidth
                                    value={leaveReason}
                                    onChange={(e) => setLeaveReason(e.target.value)}
                                    placeholder="Please provide details about your leave request"
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions sx={{ p: 3, pt: 0 }}>
                        <Button
                            onClick={handleLeavesPopupClose}
                            variant="outlined"
                            sx={{ borderRadius: '8px', px: 3 }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleSubmitRequest}
                            variant="contained"
                            disabled={isSubmitting}
                            sx={{
                                borderRadius: '8px',
                                px: 3,
                                ml: 2,
                                position: 'relative'
                            }}
                        >
                            {isSubmitting ? (
                                <>
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            marginTop: '-12px',
                                            marginLeft: '-12px',
                                        }}
                                    />
                                    Submitting...
                                </>
                            ) : (
                                'Submit Request'
                            )}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={isHolidaysPopupOpen}
                    onClose={handleHolidaysListClose}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: '16px',
                        },
                    }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(90deg, #b841d0 0%, #9c27b0 100%)',
                            p: 3,
                            color: 'white',
                            borderTopLeftRadius: '16px',
                            borderTopRightRadius: '16px',
                        }}
                    >
                        <Typography variant="h5" fontWeight="500">
                            Holidays List
                        </Typography>
                    </Box>
                    <DialogContent sx={{ p: 3 }}>
                        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FormControl sx={{ minWidth: 120 }}>
                                <InputLabel id="year-select-label">Year</InputLabel>
                                <Select
                                    labelId="year-select-label"
                                    value={holidayYear}
                                    onChange={handleYearChange}
                                    label="Year"
                                    sx={{ borderRadius: '8px' }}
                                >
                                    {years.map((year) => (
                                        <MenuItem key={year} value={year}>{year}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                <IconButton onClick={handleDownloadCalendar}>
                                    <FileDownloadOutlinedIcon />
                                </IconButton>
                            </Box>
                        </Box>
                        {loadingHolidays ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                                <CircularProgress />
                            </Box>
                        ) : holidayError ? (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {holidayError}
                            </Alert>
                        ) : (
                            <>
                                {holidays.length > 0 ? (
                                    <>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                            Showing holidays for {holidayYear}
                                        </Typography>
                                        <TableContainer component={Paper} sx={{ borderRadius: '8px', boxShadow: 2 }}>
                                            <Table>
                                                <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                                                    <TableRow>
                                                        <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold' }}>Day</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold' }}>Holiday Name</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {holidays
                                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        .map((holiday) => (
                                                            <TableRow key={holiday.id} hover>
                                                                <TableCell>{formatDate(holiday.date)}</TableCell>
                                                                <TableCell>{getDayOfWeek(holiday.date)}</TableCell>
                                                                <TableCell>
                                                                    <Typography variant="body2" fontWeight="medium">
                                                                        {holiday.holiday_name}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Chip
                                                                        label={holiday.holiday_type || "General"}
                                                                        size="small"
                                                                        sx={{
                                                                            backgroundColor: '#e3f2fd',
                                                                            color: '#1565c0',
                                                                            fontWeight: 500,
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25]}
                                                component="div"
                                                count={holidays.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handlePageChange}
                                                onRowsPerPageChange={handleRowsPerPageChange}
                                            />
                                        </TableContainer>
                                    </>
                                ) : (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 6 }}>
                                        <WbSunnyIcon sx={{ fontSize: 60, color: '#9e9e9e' }} />
                                        <Typography variant="h6" color="text.secondary">
                                            No holidays found
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            There are no holidays listed for {holidayYear}
                                        </Typography>
                                    </Box>
                                )}
                            </>
                        )}
                    </DialogContent>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            p: 3,
                            background: '#f8f9fa',
                            borderTop: '1px solid #eee',
                            borderBottomLeftRadius: '16px',
                            borderBottomRightRadius: '16px',
                        }}
                    >
                        <Button
                            onClick={handleHolidaysListClose}
                            variant="contained"
                            sx={{
                                borderRadius: 8,
                                px: 3,
                                py: 1,
                                backgroundColor: '#9c27b0',
                                '&:hover': {
                                    backgroundColor: '#7b1fa2'
                                }
                            }}
                        >
                            Close
                        </Button>
                    </Box>
                </Dialog>
                <Modal
                    open={isLeaveBalanceButtonOpen}
                    onClose={() => {
                        setIsLeaveBalanceButtonOpen(false);
                        setError(null);
                    }}
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: { xs: '90%', sm: 700, md: 800 },
                            maxHeight: '90vh',
                            overflowY: 'auto',
                            bgcolor: 'background.paper',
                            boxShadow: 24,
                            borderRadius: 2,
                            p: 4,
                            outline: 'none',
                        }}
                    >
                        <Card sx={{ boxShadow: 'none', borderRadius: 2 }}>
                            <CardContent sx={{ p: 0 }}>
                                <Typography variant="h5" sx={{ mb: 3, color: '#1976d2', fontWeight: 'bold' }}>
                                    Leave Balance Overview
                                </Typography>
                                {loading && (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                                        <CircularProgress />
                                    </Box>
                                )}
                                {error && (
                                    <Alert severity="error" sx={{ mb: 2 }}>
                                        {error}
                                    </Alert>
                                )}
                                {!loading && !error && leaveData.length === 0 && (
                                    <Alert severity="info">No leave balance data available.</Alert>
                                )}
                                {!loading && !error && leaveData.length > 0 && (
                                    <>
                                        {/* Regular Leaves (Sick, Casual) */}
                                        <Typography variant="subtitle1" sx={{ mb: 2, color: '#1976d2', fontWeight: 'bold' }}>
                                            Regular Leaves
                                        </Typography>
                                        <Grid container spacing={3} sx={{ mb: 4 }}>
                                            {leaveData.filter(leave =>
                                                leave.leave_type !== "Work From Home" &&
                                                leave.leave_type !== "Loss Of Pay"
                                            ).map((leave) => {
                                                const progressValue = leave.allocated_days > 0
                                                    ? (leave.used_days / leave.allocated_days) * 100
                                                    : 0;
                                                const displayType = leave.leave_type.charAt(0).toUpperCase() + leave.leave_type.slice(1);

                                                return (
                                                    <Grid item xs={12} sm={6} key={leave.leave_type_id}>
                                                        <Box
                                                            sx={{
                                                                p: 2,
                                                                borderRadius: 1,
                                                                bgcolor: alpha('#1976d2', 0.05),
                                                                height: '100%',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'space-between',
                                                            }}
                                                        >
                                                            <Typography variant="subtitle1" sx={{ mb: 1, color: '#1976d2', fontWeight: 'bold', fontSize: '18px' }}>
                                                                {displayType}
                                                            </Typography>
                                                            <Box sx={{ mb: 2 }}>
                                                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                                                    <Box component="span" color={labelColor}>Total:</Box>{' '}
                                                                    <Box component="span" sx={{ color: valueColor, fontWeight: 'bold' }}>
                                                                        {leave.allocated_days} days
                                                                    </Box>
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                                                    <Box component="span" color={labelColor}>Used:</Box>{' '}
                                                                    <Box component="span" sx={{ color: valueColor, fontWeight: 'bold' }}>
                                                                        {leave.used_days} days
                                                                    </Box>
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                                                    <Box component="span" color={labelColor}>Remaining:</Box>{' '}
                                                                    <Box component="span" sx={{ color: valueColor, fontWeight: 'bold' }}>
                                                                        {leave.allocated_days - leave.used_days} days
                                                                    </Box>
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ width: '100%' }}>
                                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        {progressValue.toFixed(0)}% used
                                                                    </Typography>
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        {leave.allocated_days - leave.used_days} days left
                                                                    </Typography>
                                                                </Box>
                                                                <LinearProgress
                                                                    variant="determinate"
                                                                    value={progressValue}
                                                                    sx={{
                                                                        height: 8,
                                                                        borderRadius: 4,
                                                                        bgcolor: alpha('#1976d2', 0.2),
                                                                        '& .MuiLinearProgress-bar': {
                                                                            bgcolor: progressValue > 80 ? '#f44336' : progressValue > 50 ? '#ff9800' : '#4caf50',
                                                                        },
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>

                                        {/* Other Leaves (Work From Home, Loss Of Pay) */}
                                        <Typography variant="subtitle1" sx={{ mb: 2, color: '#1976d2', fontWeight: 'bold' }}>
                                            Other Leaves
                                        </Typography>
                                        <Grid container spacing={3}>
                                            {leaveData.filter(leave =>
                                                leave.leave_type === "Work From Home" ||
                                                leave.leave_type === "Loss Of Pay"
                                            ).map((leave) => {
                                                const displayType = leave.leave_type.charAt(0).toUpperCase() + leave.leave_type.slice(1);
                                                const usedDays = leave.used_days !== null ? leave.used_days : 0;

                                                return (
                                                    <Grid item xs={12} sm={6} key={leave.leave_type_id}>
                                                        <Box
                                                            sx={{
                                                                p: 2,
                                                                borderRadius: 1,
                                                                bgcolor: alpha('#1976d2', 0.05),
                                                                height: '100%',
                                                            }}
                                                        >
                                                            <Typography variant="subtitle1" sx={{ mb: 1, color: '#1976d2', fontWeight: 'bold', fontSize: '18px' }}>
                                                                {displayType}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                                                <Box component="span" color={labelColor}>Used:</Box>{' '}
                                                                <Box component="span" sx={{ color: valueColor, fontWeight: 'bold' }}>
                                                                    {usedDays} days
                                                                </Box>
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>
                                    </>
                                )}
                            </CardContent>
                        </Card>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setIsLeaveBalanceButtonOpen(false);
                                    setError(null);
                                }}
                                sx={{
                                    borderRadius: 2,
                                    px: 3,
                                    py: 1,
                                    backgroundColor: '#1976d2',
                                    '&:hover': {
                                        backgroundColor: '#1565c0'
                                    }
                                }}
                            >
                                Close
                            </Button>
                        </Box>
                    </Box>
                </Modal>
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert
                        onClose={handleSnackbarClose}
                        severity={snackbar.severity}
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </Box>

{/* 
            {openTokenExpirePopup && (
                <TokenExpirePopup
                    open={openTokenExpirePopup}
                    onClose={handleCloseTokenExpirePopup}
                />
            )} */}
        </div>
    );
};

export default EmployeeLeaveManagement;